<!-- DIGITACAO DE NOTA FISCAL (POR PEDIDO VENDA, SAÍDAS, ENTRADAS)

FALTA:
- DESCARTAR ALTERACOES (ver o objeto _nf)
- CONCLUIR DIGITACAO DA NF SOMENTE SE POSSUIR CERTIFICADO (PENDENTE)
- FALTA CAMPO FORMA DE PAGAMENTO


NOTA FISCAL MANUAL:
nf-list: incluir nf de venda, outras nfs
- carregar o padrão item "complemento" quando nf de complemento

-->

<script>
import Trap from 'vue-focus-lock'
import { SysVars } from '../main';
import { arr, calcDesconto } from '../shared/numbers'
import { getText, formatDate, formatValue, stringToInteger } from '../shared/utils'
import { apiORDS, apiORDSpost, apiORDSdelete, apiValidaLimitePlano, apiDownloadPDF, apiDownload, apiEmailPDF } from '../shared/api-functions'
import nfsaidaItem from './nfsaida-item'
import nfFormRef from './nf-form-ref'
import nfFormNumero from './nf-form-numero'
import CustomerForm from './customer-form'
import NatesForm from './nates-form'
import EstoqueEntrada from '../forms-estoque/estoque-entrada'
import EstoqueSaida from '../forms-estoque/estoque-saida'
import MsgBannerModal from '../components/msg-banner-modal'

import autorizaNFe from '../api/api-nfe.js'
import apiNfItem from '../api/api-nf-item.js'
import Tourguide from 'tourguidejs';

import nfsaidaModalNfxml from "./nfsaida-form-modal-nfxml.vue";
import nfeEventosForm from "./nfe-eventos-form";

export default {
  props: {
    params: {},  //outrasSaidas: false, outrasEntradas: false, codpedv: 0, codnf: 0
    crud: '',
  },

  components: {
    Trap, nfsaidaItem, nfFormRef, nfFormNumero, CustomerForm, NatesForm, EstoqueEntrada, EstoqueSaida, Tourguide, nfsaidaModalNfxml, MsgBannerModal, nfeEventosForm
  },

  data() {
    return {
      view: false,                //variavel para controle de visualizacao ou edicao
      formCab: false,             //editando cabecalho da nf
      formPar: false,             //editando parcelas da nf
      formNF: false,
      formIncluir: false,         //exibe formulario para inclusao de notas (campos participante e natureza)
      nfOutrasNotas: false,       //inclusao de outras notas de saida
      nfVendaLivre: false,        //nota de venda sem pedido
      nfVendaNfce: false,        //nota de venda sem pedido
      showFormItem: false,        //exibe o formulario de manutencao de item do pedido
      showNumeroForm: false,      //exibe o formulario para alteracao do numero da nf
      showPartForm: false,        //exibe o formulario de participante para inclusao
      showNatesForm: false, //exibe o formulario de naturezas para inclusao
      showCancel: false,          //exibe a justificativa do cancelamento
      showCorrecao: false,        //exibe a tela para emissao da carta de correção
      showEventos: false,
      defaultTpEvento: '',
      defaultTpEventoAut: '',
      defaultNProtEvento: '',
      showModalNfxml: false,
      formItemView: false,
      CANCEL_ITEM_MESSAGE: false,
      DELETE_ITEM_MESSAGE: false,
      showFormEmail: false,
      showFormEmailCC: false,
      showTotal: false,
      modalExcluir: false,
      showNewTaxes: false,
      modalBannerIBSCBS: false,
      entradaArmazenamento: false,

      updateItem: false, //indica quando for uma alteracao de item

      notaFiscalDemo: false,
      dadosNotaFiscalDemo: null,

      //entidades
      nf: { ...this.$store.getters.getEntities.nf },
      nfit: [],
      nfpar: [],              //parcelas da nf
      nfref: [],              //notas referenciadas
      selectedNf: [],         //notas de origem
      _nf: {},                //objeto utilizado para funcionalidade do botao descartar
      nfit_delete: null,
      metadata: { ... this.$store.getters.getEntities.metadata },
      errmessages: [],        //armazena as mensagens de validacao da nf apos a gravacao
      textocorrecao: '',
      textocorrecao_anterior: '',
      errCorrecao: [],

      codpedv: 0,
      codcompra: 0,
      codnf: 0,

      codpart: 0, //codigo do participante para alteracao
      crudPart: '',  //inclusao ou alteracao de participante
      transportadora: false,

      codmenCpl: '',  //mensagem complementar
      codmenFisco: '', //mensagem fisco

      enderecoEntrega: false,
      enderecoRetirada: false,

      nfit_update: {},
      paramItem: {},

      unwatch: true,
      natRetorno: false,

      moreActions: [],  //botao mais acoes

      tabs: [{ title: 'Produtos da Nota' }, { title: 'Eventos' }], //paginas
      activeTab: 0, //pagina ativa

      showFormEstoqueEntrada: false,
      showEstoqueSaida: false,
      controleEstoqueHabilitado: false,

      excluirArmazenamento: false,
      excluirEstoqueSaida: false,

      editNfRef: false,

      hasManyNfs: false,
      steps: [
        {
          "selector": "",
          "step": 1,
          "title": `Vamos começar!`,
          "content": "Vamos te guiar passo a passo por todo o processo de emissão de Nota Fiscal.</br></br><a href='javascript:void(0)' class='btn btn-sm btn-danger text-white' onclick='window.dispatchEvent(new CustomEvent(\"desativar-guia\"))'>Não mostrar este guia</a>",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#part",
          "step": 2,
          "title": `Cliente`,
          "content": "Informe o cliente da nota fiscal.",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#codnates",
          "step": 3,
          "title": `Natureza de Operação`,
          "content": "Informe a natureza de operação da nota fiscal.",
          // "image": "https://somehost.com/image.jpeg"
        },
        {
          "selector": "#cfop",
          "step": 4,
          "title": `Código CFOP`,
          "content": "Informe o código da CFOP da nota fiscal.",
          // "image": "https://somehost.com/image.jpeg"
        },

      ],


    }
  },

  computed: {

    appERP: function () {
      return SysVars.appERP
    },

    titleParticipante: function () {
      if (this.nf.venda == 'S')
        return 'Cliente'
      else
        if (this.nf.operacaonf == 'S')
          return 'Cliente/Destinatário'
        else
          if (this.nf.operacaonf)
            return 'Fornecedor/Remetente'
    },

    ambienteHomologacao: function () {
      return Sysvars.ambienteHomologacao
    },

    entradaArmazenamentoPendente: function () {
      //habilitar e mostrar mensagem para efetuar armazenamento da nota
      if (!this.controleEstoqueHabilitado)
        return null

      if ((this.nf) && (this.nf.stnf) && (this.nf.stnf == '01' || this.nf.stnf == '11'))
        if (this.nf.operacaonf == 'E' && this.nf.movest == 'S' && this.nf.flagarmazenada == 'N')
          return 'Efetue o armazenamento do estoque da nota de entrada.'
        else
          return null
      else
        return null
    },

    entradaArmazenamentoConcluido: function () {
      //mensagem para visualizar armazenamento da nota
      if (this.nf.operacaonf == 'E' && this.nf.movest == 'S' && this.nf.flagarmazenada == 'S')
        return 'Nota fiscal com estoque armazenado.'
      else
        return null
    },

    saidaEstoqueBaixado: function () {
      if (this.nf.operacaonf == 'S' && this.nf.flagestoquebaixado == 'S')
        return 'Nota fiscal com estoque baixado. Alterações não são permitidas.'
      else
        return null
    },

    saidaEstoquePendente: function () {
      if (!this.controleEstoqueHabilitado)
        return null
      if (this.nf.operacaonf == 'S' && this.nf.movest == 'S' && this.nf.stnf == '01' && this.nf.flagsempedido == 'S' && this.nf.flagestoquebaixado != 'S')
        return 'Efetue a baixa de estoque da nota fiscal para concluir.'
      else
        return null
    },

    _alteraNumero: function () {
      return !this.isView && this.nf.emissaopropria == 'S' && (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50')
    },

    habilitaBotaoProduto: function () {
      return !this.isView && (this.nfOutrasNotas || this.nfVendaLivre) && !this.nf.codpedv && (this.nf.flagestoquebaixado != 'S') && (this.nf.flagarmazenada != 'S')
    },

    habilitaDuplicata: function () {
      return (this.selectedNates && this.selectedNates.calcdup == 'S') && (this.nf.operacaonf == 'E' || (this.nfOutrasNotas || this.nfVendaLivre))
    },

    deleteItem: function () {
      return !this.isView && (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50') && !this.nf.codpedv && (this.nf.flagestoquebaixado != 'S') && (this.nf.flagarmazenada != 'S')
    },

    editItem: function () {
      return !this.isView && (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50')
    },

    nfAutorizada: function () {
      return this.nf.stnf === '10'
    },

    nfAguardando: function () {
      return this.nf.emissaopropria === 'S' && (this.nf.stnf === '01' || this.nf.stnf === '50')
    },

    isView: function () {
      //nao possibilita edicao da nf quando status diferente de 00 (digitacao), 01 (pendente), 11 (lançada), 50 (rejeitada)
      if (this.view)
        return true
      else {
        const stnfVal = this.nf.stnf ? String(this.nf.stnf).padStart(2, '0') : '';
        return (stnfVal !== '00' && stnfVal !== '01' && stnfVal !== '11' && stnfVal !== '50') ||
          (this.nf.fin_baixado > 0) || (this.nf.fin_remessa > 0)
      }
    },

    nfPossuiEvento: function () {
      //checa se a nf possui evento
      let evento = false

      evento = (this.nf.nfxml && this.nf.nfxml.length > 0 && this.nf.nfxml[0].nprotcan)
      if (!evento) {
        evento = (this.nf.nfev && this.nf.nfev.length > 0)
      }
      return evento
    },

    nfExportacao: function () {
      return (this.nf.operacaonf == 'S' && this.nf.part && this.nf.part.length > 0 && this.nf.part[0].uf == 'EX')
    },

    nfImportacao: function () {
      return (this.nf.operacaonf == 'E' && this.nf.part && this.nf.part.length > 0 && this.nf.part[0].uf == 'EX')
    },

    selectedPart: function () {
      return this.$store.getters.getPart
    },

    parcelas: {
      // getter
      get: function () {
        return this.nf.parcelas
      },
      // setter
      set: function (newValue) {
        this.nf.parcelas = newValue
        this.calculaParcelas()
      }
    },

    stnf: function () {
      return getText(this.nf.stnf, this.metadata.nf.stnf)
    },

    title: function () {
      if (this.nf.operacaonf == 'E') {
        return 'Nota Fiscal de Entrada '
      } else
        if (this.nfOutrasNotas) {
          return 'Nota Fiscal de Saída '
        }
        else {
          return 'Nota Fiscal de Venda '
        }
    },

    _codpart: function () {
      return this.nf.codpart
    },

    codnates: function () {
      return this.nf.codnates
    },

    selectedNates: function () {
      return this.$store.getters.getNates
    },

    _nomeuf: function () {
      if (this.nf.part && this.nf.part.length > 0) {
        if (this.nf.part[0].nomeuf) {
          return this.nf.part[0].nomeuf
        } else if (this.nf.part[0].estado) {
          return this.nf.part[0].estado[0].nomeuf
        }
      }
    },

    _nomemun: function () {
      if (this.nf.part && this.nf.part.length > 0) {
        if (this.nf.part[0].nomemun) {
          return this.nf.part[0].nomemun
        } else if (this.nf.part[0].mun) {
          return this.nf.part[0].mun[0].nomemun
        }
      }
    },
    _toticmsst: function () {
      return this.nf.toticmst + this.nf.totfcpst
    },

    appLoja: function () {
      return SysVars.appLoja
    },

    showGuia: function () {
      return SysVars.guia
    }


  },

  watch: {
    'nf.codfil': function () {
      this.isControleEstoqueAtivado(this.nf.codfil)
    },
    'nf.emissaopropria': function () {
      if (this.nf.emissaopropria == 'S' && this.nf.operacaonf == 'E' && !this.nf.codnf) {
        this.nf.nf = null
        this.nf.serie = null
        this.nf.chave = null
      }
    },
    'nf.totger': function () {
      this.calculaParcelas()
    },
    'nf.tpfrete': function () {
      this.metadata.nf.codparttr.validator = { required: true }
      if (this.nf.tpfrete == '9') {
        this.metadata.nf.codparttr.validator = null
        // this.$validator.excludeField('codpart')
      }
      this.$validator.reset()
    },
    'nf.finalidade': function () {
      this.metadata.nf.codpart.validator = { required: true }
      if (this.nf.finalidade == 'F') {
        this.metadata.nf.codpart.validator = null
        // this.$validator.excludeField('codpart')
      }
      this.$validator.reset()

    },

    _codpart: function (newValue, oldValue) {
      //CARREGA DADOS DO PARTICIPANTE QUANDO ALTERADO
      if (newValue != oldValue) {
        this.$store.dispatch('loadPart', { id: this.nf.codpart })
      }
    },

    selectedPart: function () {
      //atualiza os dados do participante quando informado o codigo
      if (this.unwatch) {
        return
      }
      this.nf.part = this.selectedPart
      if (this.nf.part && this.nf.part.length > 0) {
        this.nf.finalidade = this.nf.part[0].tpcliente
        if (((this.nf.part[0].contricms == 'N') && (!this.nf.finalidade)) || (this.nf.nfce == 'S')) //evitar rejeição
          this.nf.finalidade = 'F'

        if (this.nf.part[0].codnates && this.nf.venda == 'S')
          this.nf.codnates = this.nf.part[0].codnates

        if (this.nf.operacaonf === 'S' && this.nf.part[0].codnatfinrec && this.nf.venda == 'S')
          this.nf.codnatfin = this.nf.part[0].codnatfinrec

        if (this.nf.operacaonf === 'E' && this.nf.part[0].codnatfindes)
          this.nf.codnatfin = this.nf.part[0].codnatfindes
      }
    },

    codnates: function () {
      // if (this.unwatch) {
      //     return
      // }
      this.$store.dispatch('loadNates', { id: this.nf.codnates })
    },

    selectedNates: function () {
      //HABILITA CAMPO DE NOTA REFERENCIADA CONFORME TIPO DE NATUREZA INFORMADA (DEVOLUCAO, AJUSTE, COMPLEMENTO)

      if (this.unwatch) {
        return
      }
      this.nf.nates = this.selectedNates
      this.nf.cfop = this.nf.nates.cfop
      this.nf.tpnf = this.nf.nates.tpnf
      this.checkAvisoNaturezaIcmFilialSemIE(this.selectedNates)

      if (this.nf.tpnf !== 'CR') {
        this.nf.tpnfcredito = null
      }
      if (this.nf.tpnf !== 'DB') {
        this.nf.tpnfdebito = null
      }

      //NOTA FISCAL DE INDUSTRIALIZACAO PERMITE INFORMAR NATUREZA DE RETORNO
      if (this.nf.operacaonf === 'S') {
        if (this.nf.tpnf === 'I' || this.selectedNates.tpnf === 'I') {
          this.natRetorno = true
        } else {
          this.natRetorno = false
        }
      }

    },

    codmenCpl: function () {
      if (this.codmenCpl) {
        this.loadInfCpl()
      }
    },

    codmenFisco: function () {
      if (this.codmenFisco) {
        this.loadInfAdFisco()
      }
    },

  },

  mixins: [autorizaNFe, apiNfItem],

  methods: {
    isNfRefLinked(nf) {
      if (!this.nfit || this.nfit.length === 0) return false;
      return this.nfit.some(it => {
        if (nf.chave && it.chaveorigem &&
            String(nf.chave).trim().toLowerCase() === String(it.chaveorigem).trim().toLowerCase()) {
          return true;
        }
        if (nf.codnfref && it.codnforigem &&
            Number(nf.codnfref) === Number(it.codnforigem)) {
          return true;
        }
        return false;
      });
    },

    handleConfirmBannerIBSCBS() {
      localStorage.setItem('nfsaida-form-banner-ibscbs', true)
    },

    async checkAvisoNaturezaIcmFilialSemIE(nates) {
      if (!nates || this.unwatch) return
      if (nates.calcicm !== 'S') return
      if (nates.tpnf === 'D') return
      const cfopStr = String(nates.cfop || '').trim()
      if (cfopStr.startsWith('12') || cfopStr.startsWith('22') || cfopStr.startsWith('52') || cfopStr.startsWith('62')) {
        return
      }
      let codfil = (this.nf ? this.nf.codfil : null) || (this.$store.getters.getFilial ? this.$store.getters.getFilial.codfil : null)
      if (codfil) {
        await this.$store.dispatch('loadFilial', { id: codfil })
      }
      let filial = this.$store.getters.getFilial
      if (filial && (!filial.iest || String(filial.iest).trim() === '')) {
        this.$erpToastWarning(
          'Aviso: A filial emitente não possui Inscrição Estadual (contribuinte exclusivo IBS/CBS) e a natureza selecionada calcula ICMS. Operações com destaque de ICMS são rejeitadas pela SEFAZ (NT 2026.007), exceto em devoluções.'
        )
      }
    },

    closeModalNfxml() {
      this.showModalNfxml = false
    },
    handleInformaNfxml({ xml, chave, nprot }) {
      this.closeModalNfxml();
      if (!this.nf.nfxmlinfo)
        this.$set(this.nf, 'nfxmlinfo', {})
      this.nf.nfxmlinfo.xml = xml
      this.nf.nfxmlinfo.chave = chave
      this.nf.chave = chave
      this.nf.nfxmlinfo.nprot = nprot
      this.apiInvoice()
    },

    closeForm() {
      if (this.$route.params.id == 'novo')
        this.$router.go(-1)
      else
        this.$emit('closeform')
    },


    handleChangeValores() {
      if (this.nf.stnf != '00' && this.nf.stnf != '01' && this.nf.stnf != '11' && this.nf.stnf != '50')
        return

      this.nf.totger = this.nf.totmer + this.nf.totser + this.nf.vlrfre + this.nf.vlrdesp + this.nf.vlrseg - this.nf.vlrdesc +
        this.nf.totipi + this.nf.toticmst + this.nf.totipidevol

      this.nf.stnf = '00'
    },

    async getParcelasFormapagParametrosFilial(codfil) {
      //checa se possui controle de estoque na filial
      if (!codfil)
        return '15'

      let parametros = {}

      await this.$store.dispatch('loadFilial', { id: codfil })
      if (this.$store.getters.getFilial) {
        let filial = this.$store.getters.getFilial
        if (filial.parametros) {
          parametros = JSON.parse(filial.parametros)
        }
      }

      if (parametros)
        if (parametros.parcelas)
          if (parametros.parcelas.formapag)
            return parametros.parcelas.formapag;
      return '15';
    },

    closeNatesForm(id) {
      //ao fechar o formulario de inclusao de naturezas
      if (id) this.nf.codnates = id
      this.showNatesForm = false
    },

    handleIncluirNates() {
      //exibe tela de cadastro da natureza
      this.showNatesForm = true
    },

    async isControleEstoqueAtivado(codfil) {
      //checa se possui controle de estoque na filial
      if (!codfil) {
        this.controleEstoqueHabilitado = false
        return
      }

      let parametros = {}

      await this.$store.dispatch('loadFilial', { id: codfil })
      if (this.$store.getters.getFilial) {
        let filial = this.$store.getters.getFilial
        if (filial.parametros) {
          parametros = JSON.parse(filial.parametros)
        }
      }
      this.controleEstoqueHabilitado = parametros.controlaestoque
    },

    handleArmazenarEntrada() {
      this.$modalForm(true)
      this.excluirArmazenamento = false
      this.showFormEstoqueEntrada = true
    },

    handleExcluirentradaarmazenamento() {
      this.$modalForm(true)
      this.excluirArmazenamento = true
      this.showFormEstoqueEntrada = true
    },

    closeEstoqueForm() {
      this.$modalForm(false)
      this.showFormEstoqueEntrada = false
      this.showEstoqueSaida = false
      this.codnf = this.nf.codnf
      this.loadData()
    },

    handleEstoqueSaida() {
      this.$modalForm(true)
      this.excluirEstoqueSaida = false
      this.showEstoqueSaida = true
    },

    handleExcluirEstoqueSaida() {
      this.$modalForm(true)
      this.excluirEstoqueSaida = true
      this.showEstoqueSaida = true
    },

    // async loadAmbienteNFe () {
    //   await this.$store.dispatch('loadFilial', {})
    //   this.ambienteNFe = this.$store.getters.getFilialList[0].tpambnfe == '2'
    // },

    showNfRef() {
      //habilita botao de notas referenciadas/selecao de notas de origem
      //notas de complemento, ajuste, devolucao, retorno, credito e debito
      let ref = (this.nf.nates && (this.nf.nates.tpnf == 'P' || this.nf.nates.tpnf == 'A' || this.nf.nates.tpnf == 'D' || this.nf.nates.tpnf == 'T' || this.nf.nates.tpnf == 'I' || this.nf.nates.tpnf == 'CR' || this.nf.nates.tpnf == 'DB'))
      return ref
    },

    async loadInfCpl() {
      await this.$store.dispatch('loadMennf', { id: this.codmenCpl })
      if (this.$store.getters.getMennf.texto) {
        if (this.nf.obs) {
          this.nf.obs = this.nf.obs + this.$store.getters.getMennf.texto
        } else {
          this.nf.obs = this.$store.getters.getMennf.texto
        }
      }
    },

    async loadInfAdFisco() {
      await this.$store.dispatch('loadMennf', { id: this.codmenFisco })
      if (this.$store.getters.getMennf.texto) {
        if (this.nf.obsfisco) {
          this.nf.obsfisco = this.nf.obsfisco + this.$store.getters.getMennf.texto
        } else {
          this.nf.obsfisco = this.$store.getters.getMennf.texto
        }
      }
    },

    data(value) {
      return formatDate(value)
    },

    closeNumeroForm() {
      this.showNumeroForm = false
    },

    handleUpdateNumero() {
      //BOTAO ALTERAR NUMERO DA NOTA
      this.showNumeroForm = true
    },

    handleAlterarOutras() {
      this.formCab = true
    },

    updateNumero() {
      //EFETUA A ALTERACAO DA NUMERACAO DA NF E GRAVA A NF
      this.closeNumeroForm()
      this.nf.updatenumero = true
      this.apiInvoice()
    },

    handleIncluirPart(transportadora) {
      //abre tela para inclusao de cliente ou transportadora
      this.crudPart = SysVars.crudI
      this.transportadora = false
      if (transportadora) {
        this.transportadora = true
      }
      this.showPartForm = true
    },

    handleAlterarPart(transportadora) {
      //abre tela de alteracao de participante (participante ou transportadora)
      this.crudPart = SysVars.crudU
      this.transportadora = false
      if (transportadora) {
        this.codpart = this.nf.codparttr //alteracao de transportadora
        this.transportadora = true
      } else {
        this.codpart = this.nf.codpart //alteracao de cliente
      }
      this.showPartForm = true
    },

    closeCustomerForm(part) {
      //ao fechar o formulario de inclusao de participantes
      this.showPartForm = false
      if (part && part.length > 0) {  //se um novo participante foi incluido
        if (this.transportadora) {
          this.nf.parttr = part  //carrega a transportadora incluida
          this.nf.codparttr = part[0].codpart
        } else {
          this.nf.part = part     //carrega o cliente incluido
          this.nf.codpart = part[0].codpart
        }
      }
    },

    handleActions(action) {
      //duplica a nota fiscal
      if (action == 4) {
      }

      //enviar email
      if (action == 1) {
        this.handleFormEmailDanfe()
      }

      //imprimir danfe
      if (action == 2) {
        this.imprimirDANFE(false)
      }

      //preview da danfe
      if (action == 11) {
        if (this.nf.esp == '59') {
          this.$erpToastError('A Pré NOTA só pode ser visualizada no modelo SAT.')
        } else {
          this.imprimirDANFE(true)
        }
      }

      if (action == 12) {
        this.$router.push('/banking?codnf=' + this.nf.codnf)
      }

      //cancela a nota fiscal
      if (action == 3) {
        this.showCancel = true
        this.$nextTick(function () {
          this.$refs.obscan.focus()
        })
      }

      //exclui a nota fiscal
      if (action == 5) {
        this.modalExcluir = true;
      }

      //download do xml
      if (action == 6) {
        this.downloadXML()
      }

      //autorizacao
      if (action == 7) {
        let vm = this
        this.nf.stnf = '01'
        this.apiInvoice(false, true)
      }

      //emitir correcao
      if (action == 8) {
        this.errCorrecao = []
        this.showCorrecao = true
        this.$nextTick(function () {
          this.$refs.correcao.focus()
        })
      }

      //emitir cce
      if (action == 9) {
        this.imprimirCC()
      }

      //enviar cce por email
      if (action == 10) {
        this.handleFormEmailCC()
      }

      //excluir armazenamento
      if (action == 20) {
        this.handleExcluirentradaarmazenamento()
      }

      //excluir armazenamento
      if (action == 21) {
        this.handleExcluirEstoqueSaida()
      }

      if (action == 22) {
        this.showModalNfxml = true
      }

      if (action == 30) {
        this.handleEmitirEvento()
      }


    },

    handleExcluir() {
      this.modalExcluir = false;
      this.apiInvoiceDelete()
    },

    closeModal() {
      this.modalExcluir = false;
      this.modalBannerIBSCBS = false;
    },

    handleCancel() {
      //botao confirmacao de cancelamento da nf
      if (this.nf.obscan == null) {
        this.$erpToastError('Por favor preencha a justificativa para continuar')
        return
      }
      if (String(this.nf.obscan).length < 15) {
        this.$erpToastError('O texto do cancelamento deve possuir no mínimo 15 caracteres')
        return
      }
      if (String(this.nf.obscan).length > 255) {
        this.$erpToastError('O texto do cancelamento deve possuir no máximo 255 caracteres')
        return
      }
      this.apiInvoiceCancel()
    },

    handleCorrecao() {
      //botao confirmacao de cancelamento da nf
      this.textocorrecao = this.$removerAcentos(this.textocorrecao)
      if (this.textocorrecao)
        this.textocorrecao = this.textocorrecao.replace(/(\r\n|\n|\r)/gm, "")

      if (this.textocorrecao == '') {
        this.$erpToastError('Por favor preencha o texto da correção para continuar')
        return
      }
      if (String(this.textocorrecao).length < 15) {
        this.$erpToastError('O texto da correção deve possuir no mínimo 15 caracteres')
        return
      }
      if (String(this.textocorrecao).length > 1000) {
        this.$erpToastError('O texto da correção deve possuir no máximo 1000 caracteres')
        return
      }
      this.apiInvoiceCorrecao()
    },

    handleCorrecaoClose() {
      //botao descartar correção da nf
      this.showCorrecao = false
    },

    handleCancelDiscard() {
      //botao descartar cancelamento da nf
      this.showCancel = false
    },

    certificadoA3() {
      let tipo = this.$certificadoCheck(this.nf.codfil);
      if (this.esp == '59') {
        this.$erpToastError('A Pré NOTA não pode ser visualizada no modelo SAT.')
        return false
      } else if (tipo == 'A3') {
        this.$erpToastError('A Pré NOTA só pode ser visualizada com certificado A1.')
        return false
      } else if (tipo == 'A1') {
        return true
      } else {
        return false
      }
    },

    handleIncluir() {
      //INCLUIR NOVA NOTA FISCAL (APOS INFORMAR PARTICIPANTE E NATUREZA)
      // if (this.nf.codpart == null || this.nf.codnates == null || this.nf.cfop == null) {
      //     this.$erpToastError('Por favor preencha os campos para continuar')
      //     return
      // }

      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          let isValidCabec = true
          if (this.nf.operacaonf === 'E' && this.nf.emissaopropria === 'N' && this.nf.entradaarmazenamento != 'S' && (!this.nf.nf || this.nf.nf == '0' || !this.nf.serie)) {
            this.$erpToastError('Informe a série e número da NF.')
            isValidCabec = false
          }
          if (this.nf.nates && this.nf.nates.stnates == 'I') {
            this.$erpToastError('A Natureza de saída informada está inativa')
            isValidCabec = false
          }
          if (this.nf.operacaonf === 'S' && this.nf.venda === 'S' && (this.nf.part && this.nf.part.length > 0 && this.nf.part[0].stcred != 'L')) {
            this.$erpToastError('Cliente com crédito bloqueado. Operação não permitida.')
            isValidCabec = false
          }
          if (this.nf.part && this.nf.part.lenght > 0 && this.nf.part[0].stpart == 'I') {
            this.$erpToastError('Participante inativo. Operação não permitida.')
            isValidCabec = false
          }
          if (!this.validaRef()) {
            return
          }
          if (isValidCabec) {
            this.apiInvoice()
          }
        }
      })


      // if (!this.validacaoInicial()) {
      //     return
      // }
    },

    handleRetorna() {
      //botao retornar
      //fecha a inclusao da nf
      //volta para lista de pedido ou para lista de nf
      if (this.$route.params && this.$route.params.id == 'novo')
        this.$router.go(-1)
      else
        if (this.$route.query.tipo == 'devolucao')
          this.$router.go(-1)
        else
          if (this.$route.query.tipo == 'view')
            this.$router.go(-1)
          else
          if (this.codpedv){
            if (!this.appLoja) {
                this.$router.push('/pedidolist') //retorna para a lista de pedido quando for faturamento de pedido
              } else {
                this.$router.push('/fv/pedidos') //retorna para a lista de pedido quando for faturamento de pedido
              }
            }else if (this.codcompra){
                this.$router.push('/compralist') //retorna para a lista de pedido quando for faturamento de pedido
            }
            else
              this.$emit('closeform')
    },

    calculaParcelas() {
      if (this.unwatch) return

      if (this.nf.operacaonf == 'E' && this.selectedNates
        && this.selectedNates.calcdup == 'S' && this.nf.parcelas == null) {
        this.nf.parcelas = 0;
      }

      let total = 0;
      if (this.nf.totdup)
        total = parseFloat(arr(Number.parseFloat(this.nf.totdup), 2, true))
      else
        total = parseFloat(arr(Number.parseFloat(this.nf.totger), 2, true))


      this.nfpar = [];
      let vlr = 0.0;
      let soma = 0.0;
      if (this.nf.parcelas == '0') {
        let parcela = { ...this.$store.getters.getEntities.nfpar }
        parcela.dtv = this.nf.data
        parcela.vlr = total
        parcela.obspar = ''
        parcela.error = null
        parcela.dias = 0
        this.getParcelasFormapagParametrosFilial(this.nf.codfil).then(function (v) {
          parcela.formapag = v
        });

        if (parcela.formapag == null) {
          parcela.formapag = "15"
        }

        this.nfpar.push(parcela)
      } else {
        for (var x = 1; x <= this.nf.parcelas; x++) {
          let parcela = { ...this.$store.getters.getEntities.nfpar };
          parcela.dias = x * 30;
          // parcela.dtv = this.$addMonths(this.nf.data, x);
          parcela.dtv = this.$addDays(this.nf.data, parcela.dias);
          vlr = total;
          vlr = arr(vlr / this.nf.parcelas, 2, true);
          parcela.vlr = vlr;
          soma = Number(soma) + Number(vlr);
          soma = Number((soma)).toFixed(2);

          if (x == this.nf.parcelas) {
            if (soma > total) {
              parcela.vlr = parcela.vlr - (soma - total);
            } else if (soma < total) {
              parcela.vlr = Number(parcela.vlr) + (Number(total) - Number(soma));
            }
          }

          parcela.error = null
          parcela.obspar = '';
          this.getParcelasFormapagParametrosFilial(this.nf.codfil).then(function (v) {
            parcela.formapag = v
          });

          if (parcela.formapag == null) {
            parcela.formapag = "15"
          }

          this.nfpar.push(parcela);
        }
      }
    },

    async handleAutoriza() {
      //envia nf para autorizacao
      //this.nf.stnf = ''
      if (this.nf.filial[0].cnpj == '11111111111111') {
        this.$erpToastError('Em período de trial não é possível autorizar, será exibida a pré-visualização da DANFE.')
        this.imprimirDANFE(true)
      } else {
        this.nf.xmotivo = ''
        this.$scrollTo(0)

        if (this.nf.esp == '59') {
          this.autorizaNFeSAT(this.nf, this.NFeResponseCallbackSAT)
        } else {
          let tipo = this.$certificadoCheck(this.nf.codfil)
          if (tipo == 'A1') {
            this.autorizaNFeA1(this.nf, this.NFeResponseCallbackA1)
          } else if (tipo == 'A3') {
            this.autorizaNFeA3(this.nf, this.NFeResponseCallbackA3)
          }
        }
      }

    },

    NFeResponseCallbackSAT(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO SAT
      this.errmessages = {}
      this.codnf = this.nf.codnf
      if (response.status != 'success') {
        this.$erpToastError(response.message)
      } else {
        if (response.response.nf.length > 0 && response.response.nf[0].cstat == '100') {
          this.$erpToastSuccess('NFe Autorizada')
        }
        else {
          this.updateActions()
          this.nf.xmotivo = response.response.xmotivo
          this.$erpToastError(response.response.xmotivo)
        }
      }
      this.loadData()
    },


    NFeResponseCallbackA3(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO A3
      this.errmessages = {}
      this.codnf = this.nf.codnf
      if (response.status != 'success') {
        this.$erpToastError(response.message)
      } else {
        if (response.response.nf.length > 0 && response.response.nf[0].cstat == '100') {
          this.$erpToastSuccess('NFe Autorizada')
        }
        else {
          this.updateActions()
          this.nf.xmotivo = response.response.xmotivo
          this.$erpToastError(response.response.xmotivo)
        }
      }
      this.loadData()
    },

    async NFeResponseCallbackA1() {
      this.updateActions()

      // const resp = await apiAutNFe(this, this.nf.codfil, this.nf.codnf)
      // if (resp.data) {
      //     if (resp.data.errmessages) {
      //         this.$erpToastError(resp.data.errmessages[0])
      //         this.errmessages.errmessages = resp.data.errmessages
      //     } else {
      //         if (resp.data.nf.length > 0) {
      //             if (resp.data.nf[0].cstat === '100') {
      //                 //EXIBE A MENSAGEM DE NF AUTORIZADA E ATUALIZA O STATUS E CHAVE DA NF NA TELA
      //                 this.$erpToastSuccess('Nota fiscal autorizada')
      //                 this.nf.stnf = '10'
      //                 this.nf.chave = resp.data.nf[0].chave
      //                 this.updateActions()
      //             } else {
      //                 this.nf.stnf = '50'  //NF REJEITADA
      //                 this.errmessages.errmessages = []
      //                 this.errmessages.errmessages.push(resp.data.nf[0].xmotivo)
      //                 this.$erpToastError(resp.data.nf[0].xmotivo)
      //                 this.updateActions()
      //             }
      //         }
      //         else {
      //             //LOTE REJEITADO OU AINDA NAO PROCESSADO
      //             this.nf.stnf = '50'  //NF REJEITADA
      //             //this.nf.xmotivo = resp.data.xmotivo
      //             this.errmessages.errmessages = []
      //             this.errmessages.errmessages.push(resp.data.xmotivo)
      //             this.$erpToastError(resp.data.xmotivo)
      //             this.updateActions()
      //         }
      //     }
      // }
    },

    possuiNForigem() {
      if (this.nf.tpnf === 'I' || this.selectedNates.tpnf === 'I') {
        for (let i = 0; i < this.nfref.length; i++) {
          if (this.nfref[i].codnfref != null) {
            return true;
          }
        }
      }
      return false;
      // return (this.nfref.length > 0);
    },

    validaRef() {
      //efetua a validacao das notas referenciadas
      if (!this.showNfRef()) {
        this.nfref = []
        return true
      }
      if (this.nfref.length == 0) {
        if (this.nf.tpnf !== 'DB') {
          this.$erpToastError('A Configuração da natureza de operação utilizada (' + this.nf.cfop + ') exige que seja referenciada uma chave.')
          return false
        }
      } else {
        if (this.possuiNForigem() === true && this.nf.tpnf === 'I' && this.nf.codnatesret == null) {  //NOTA DE INDUSTRIALIZACAO OBRIGA NAT DE RETORNO
          this.$erpToastError('Informe a natureza de retorno')
          return false
        }
      }
      let erro = false
      for (let i = 0; i < this.nfref.length; i++) {
        this.nfref[i].validation = {}
        if (this.nfref[i].nfreftp == 1 || this.nfref[i].nfreftp == 2) {
          if (this.nfref[i].chave == null || this.nfref[i].chave.length < 44) {
            this.nfref[i].validation.chave = 'Chave inválida'
            erro = true
          }
        } else
          if (this.nfref[i].nfreftp == 3 || this.nfref[i].nfreftp == 4) {
            if (this.nfref[i].nf == null || this.nfref[i].nf.length < 1) {
              this.nfref[i].validation.nf = 'Número da NF obrigatório'
              erro = true
            }
          }
      }
      if (erro) {
        this.$erpToastError('Por favor preencha corretamente os campos em destaque para continuar')
      }
      return !erro

    },

    handleTotalizar(close) {
      //grava a nota fiscal

      if (this.nfit.length == 0) {
        this.$erpToastError('Erro: Itens não informados.')
        return
      }

      if (this.habilitaDuplicata && this.nf.venda === 'S' && this.nf.emissaopropria === 'S' && this.nf.parcelas == null) {
        this.$nextTick(function () {
          this.$refs.parcelas.focus()
        })
        this.$erpToastError('Informe a condição de pagamento')
        return
      }

      if (this.nf.emissaopropria === 'S' && !this.nf.tpfrete) {
        this.$nextTick(function () {
          this.$refs.tpfrete.focus()
        })
        this.$erpToastError('Informe a modalidade do frete')
        return
      }

      if (this.nf.emissaopropria == 'N')
        this.nf.stnf = '11'
      else
        this.nf.stnf = '01'

      this.isTotalizarRequest = true
      this.apiInvoice(close)
    },

    async handleEditar() {
      //edita a nota fiscal de entrada (somente para nota fiscal importada por xml)
      var modulo = 'invoice/edit/' + this.nf.codnf
      const data = await apiORDSpost(this.$store, modulo, {}, 'post')
      if (data.errmessages) {
        this.$erpToastError(data.errmessages[0])
      } else {
        //RETORNA PARA A LISTA DA NOTA COM EVENTO DE EDICAO ONDE SERÁ ABERTA A TELA DE EDICAO DA NF DE ENTRADA
        this.$emit('edit', this.nf.codnf, this.nf.importxml == 'S')
        //    this.nf.stnf = '00'
        //    this.view = false
      }
    },

    async handleFaturar() {
      //fatura o pedido de venda
      var modulo = 'invoice/order/' + this.codpedv
      const data = await apiORDSpost(this.$store, modulo, {}, 'post')
      if (data.codnf) {
        this.codnf = data.codnf
        this.loadData()
      }
    },

    async handleCompra() {
      //fatura o pedido de venda
      var modulo = 'invoice/compra/' + this.codcompra
      const data = await apiORDSpost(this.$store, modulo, {}, 'post')
      if (data.codnf) {
        this.codnf = data.codnf
        this.loadData()
      }
    },


    handleDescartar() {


    },

    handleSalvarDadosAdicionais() {
      //botao salvar dados do cabecalho da nf
      this.$validator.validateAll().then(isValid => {
        if (!isValid) {
          this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
        } else {
          this.nf.stnf = '00' //obriga que o usuário totalize a nota novamente
          this.apiInvoice()
          this.closeFormCab()
        }
      })
    },

    closeFormCab() {
      this.formCab = false
    },

    async apiInvoice(close, autorizacao) {
      if (!this.handleValidaParcelas()) {
        this.$erpToastError('Erro: Parcelas com datas não permitidas.')
        return
      }

      //efetua a gravacao da nota fiscal
      let nfit = []
      nfit = this.nfit
      this.nf.nfit = nfit
      this.nf.nfpar = this.nfpar
      this.nf.nfref = this.nfref
      var sendData = {}
      sendData.nf = { ...this.nf }
      if (autorizacao)
        sendData.autorizaenvio = true

      if (this.isTotalizarRequest) {
        sendData.istotalizar = true;
        this.isTotalizarRequest = false;
      }

      let metodo = 'post'
      let update = false
      if (this.nf.codnf != null) {
        //metodo = 'put'
        update = true
      }

      var modulo = 'invoice/nf/'
      //if (cancel) {
      //  modulo = 'invoice/nf/cancel/'
      //}

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      if (data.items) {
        this.nf = data.items[0]
        this.nf.nates = this.nf.nates[0];
        this.nfit = this.nf.nfit
        this.nfref = this.nf.nfref
        this.nfpar = this.nf.nfpar
        if (this.nfErro()) {
          this.$scrollTo(0)
          this.$erpToastError('Por favor corrija os erros de validação')
          return false
        } else {
          if (update) {
            this.$erpToastSuccess('Nota fiscal gravada com sucesso')
            if (close) {
              this.handleRetorna()
              return
            }
          }
          this.errmessages = []
        }
      }
      this.updateActions()

      if (this.formIncluir && this.notaFiscalDemo)
        this.incluiProdutoNotaFiscalDemo()

      this.formIncluir = false
      this.formNF = true

      if (autorizacao)
        this.handleAutoriza()
    },

    nfErro() {
      if (!this.nf.validation)
        return false
      let validation = JSON.parse(this.nf.validation)
      if (validation.errmessages) {
        this.errmessages = validation
        return true
      } else
        return false
    },

    async apiInvoiceDelete() {
      //exclui a nota fiscal
      var modulo = 'invoice/nf/' + this.nf.codnf
      await apiORDSdelete(this.$store, modulo)
      this.$erpToastSuccess('A Nota fiscal foi excluída com sucesso.')
      this.handleRetorna()
    },

    async apiInvoiceCancel() {
      //cancela a nota fiscal
      this.errCorrecao = []

      if (this.nf.esp == '59' && this.nf.impxml != 'S') {
        let paramscancel = '&codnf=' + this.nf.codnf + '&texto=' + this.nf.obscan
        this.$executaExtensaoChromeSAT(this.nf.codnf, 'canc', this.CancelResponseCallback, paramscancel)
        return
      }

      let tipo = this.$certificadoCheck(this.nf.codfil)
      if (tipo == 'A3' && this.nf.impxml != 'S') {
        let paramscancel = '&codnf=' + this.nf.codnf + '&texto=' + this.nf.obscan
        this.$executaExtensaoChromeA3(this.nf.codnf, 'canc', this.CancelResponseCallback, paramscancel)
        return
      } else {
        let sendData = {}
        sendData = { codnf: this.nf.codnf, codfil: this.nf.codfil, just: this.nf.obscan }

        this.showCancel = false
        this.$appLoading(true)
        let modulo = 'invoice/cancel/'
        const data = await apiORDSpost(this.$store, modulo, sendData, 'post')
        if (data.errmessages) {
          this.$appLoading(false)
          this.showCancel = true
          this.errCorrecao = data.errmessages
          this.$erpToastError('A nota fiscal não foi cancelada')
          return
        } else {
          this.$appLoading(false)
          this.$erpToastSuccess('Nota fiscal cancelada com sucesso.')
          this.loadData()
        }
      }
    },

    CancelResponseCallback(response) {
      //CALLBACK QUANDO O CANCELAMENTO É ENVIADO POR CERTIFICADO A3
      this.$appLoading(false)
      this.errmessages = []
      if (response.status != 'success') {
        this.$erpToastError(response.message)
      } else {
        this.showCancel = false
        this.$erpToastSuccess('Nota fiscal cancelada com sucesso.')
        this.loadData()
      }
    },


    async apiInvoiceCorrecao() {
      //envio de carta de correcao
      this.errCorrecao = []
      let tipo = this.$certificadoCheck(this.nf.codfil)
      if (this.nf.esp == '59') {
        this.$erpToastError('A carta de correção não é permitida em modelo SAT')
        return
      } else if (tipo == 'A3') {
        let paramscce = '&codnf=' + this.nf.codnf + '&texto=' + this.textocorrecao
        this.$executaExtensaoChromeA3(this.nf.codnf, 'cce', this.CorrecaoResponseCallback, paramscce)
        return
      } else {
        let sendData = {}
        sendData = { codnf: this.nf.codnf, codfil: this.nf.codfil, correcao: this.textocorrecao, tpeventonfe: 'R' }

        this.showCorrecao = false
        this.$appLoading(true)
        const data = await apiORDSpost(this.$store, 'invoice/correcao/', sendData, 'post')
        if (data.errmessages) {
          this.$appLoading(false)
          this.errCorrecao = data.errmessages
          this.showCorrecao = true
          this.$erpToastError('A carta de correção não foi autorizada')
          return
        }
        else {
          this.$appLoading(false)
          this.$erpToastSuccess('Carta de correção homologada')
          this.loadData()
          this.handleFormEmailCC()
        }
      }
    },

    CorrecaoResponseCallback(response) {
      //CALLBACK QUANDO A CARTA DE CORREÇÃO É ENVIADA POR CERTIFICADO A3
      this.$appLoading(false)
      this.errmessages = []
      if (response.status != 'success') {
        this.$erpToastError(response.message)
      } else {
        this.showCorrecao = false
        this.$erpToastSuccess('Carta de correção homologada')
        this.loadData()
        this.handleFormEmailCC()
      }
    },

    async apiItens(nfIt, deleteItem) {
      //efetua a gravacao dos itens do pedido
      var sendData = { nf: this.nf }
      if (nfIt.length) {
        sendData.nf.nfit = nfIt
      } else {
        sendData.nf.nfit = []
        sendData.nf.nfit.push(nfIt)
      }

      var metodo = 'post'
      var modulo = 'invoice/nfit/'
      if (deleteItem) {
        modulo = modulo + 'delete/'
      }

      const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
      if (deleteItem) {
        this.codnf = this.nf.codnf
        this.loadData()
        this.$erpToastSuccess('O produto foi excluído.')
      } else
        if (data.items) {
          this.nf = data.items[0]
          this.nf.nates = this.selectedNates
          this.nfit = data.items[0].nfit
          //   this.$erpToastSuccess('Item gravado com sucesso.')
          if (this.nfErro()) {
          } else {
            this.errmessages = []
          }
        }

      this.updateItem = false
    },



    handleDeleteItemMsg(index) {
      //EXCLUI O ITEM DO PEDIDO
      this.nfit_delete = this.nfit[index]
      this.DELETE_ITEM_MESSAGE = true;
    },

    handleDeleteItem() {
      if (this.nfAutorizada) {
        this.$erpToastError('Esta nota já foi autorizada e não pode mais ser alterada.')
        this.DELETE_ITEM_MESSAGE = false;
        return
      }

      //remove o item do pedido
      this.DELETE_ITEM_MESSAGE = false;
      let item = [];
      item.push(this.nfit_delete)
      this.apiItens(item, true)
    },

    closeFormItem() {
      //fecha tela de inclusao de item
      this.showFormItem = false
      this.formNF = true
    },

    saveItem(nfit) {
      if (this.nfAutorizada) {
        this.$erpToastError('Esta nota já foi autorizada e não pode mais ser alterada.')
        this.showFormItem = false
        return
      }

      //fecha tela de alteracao de item e envia para o servidor
      this.activeTab = 0
      this.showFormItem = false
      this.formNF = true
      this.apiItens(nfit)
      this.$nextTick(function () {
        if (this.$refs.incluirProduto) {
          this.$refs.incluirProduto.focus()
        }
      })
    },

    handleIncluirItem(nSeq, view) {
      //incluir item na nf

      this.nfit_update = { ...this.$store.getters.getEntities.nfit }
      this.nfit_update.finalidade = this.nf.finalidade
      this.nfit_update.codnf = this.nf.codnf
      this.nfit_update.pcredsn = this.nf.pcredsn
      //ajusta os parametros para chamada da tela de item da nf
      this.paramItem = {
        nf: this.nf,
        nfsaida: this.nf.operacaonf == 'S',
        nfit: this.nfit_update,
        nfImportacao: this.nfImportacao,
        nfAjuste: this.nf.tpnf == 'A',
        nfComplementar: this.nf.tpnf == 'P',
        habilitaItem: (this.nfOutrasNotas || this.nfVendaLivre) && (this.nf.flagestoquebaixado != 'S') && (this.nf.flagarmazenada != 'S'),
        optSimples: this.nf.filial[0].crt == '1' || this.nf.filial[0].crt == '4',
        difal: (this.selectedPart.uf != this.nf.filial[0].uf) && (this.nf.finalidade == 'F') && (this.nf.venda == 'S'),
        ipidevol: this.nf.nates.ipidevol == 'S'
      }
      //
      this.formItemView = false //indica se é alteração ou somente visualizacao
      this.updateItem = false
      this.showFormItem = true
    },

    handleEditItem(nSeq, view) {
      //editar o item da nf
      this.nfit_update = {}

      //localiza o item para alteracao atraves da sequencia
      for (var x = 0; x < this.nfit.length; x++) {
        if (this.nfit[x].itnf == nSeq) {
          this.nfit_update = { ...this.nfit[x] }
        }
      }
      //ajusta os parametros para chamada da tela de item da nf
      this.paramItem = {
        nf: this.nf,
        nfsaida: this.nf.operacaonf == 'S',
        nfit: this.nfit_update,
        nfImportacao: this.nfImportacao,
        nfAjuste: this.nf.tpnf == 'A',
        nfComplementar: this.nf.tpnf == 'P',
        habilitaItem: (this.nfOutrasNotas || this.nfVendaLivre) && (this.nf.flagestoquebaixado != 'S') && (this.nf.flagarmazenada != 'S'),
        optSimples: this.nf.filial[0].crt == '1' || this.nf.filial[0].crt == '4',
        difal: (this.selectedPart.uf != this.nf.filial[0].uf) && (this.nf.finalidade == 'F') && (this.nf.venda == 'S'),
        isView: view,
        ipidevol: this.nf.nates.ipidevol == 'S'
      }
      //
      this.formItemView = view //indica se é alteração ou somente visualizacao
      this.updateItem = true
      this.showFormItem = true
    },

    handleCloseMessage() {
      this.CANCEL_ITEM_MESSAGE = false;
      this.DELETE_ITEM_MESSAGE = false;
    },

    updateActions() {
      this.moreActions = []
      var act = {}
      if (this.nf.emissaopropria != 'S' && (this.nf.stnf >= '11')) {
        act = { action: 5, label: 'Excluir NF' }
        this.moreActions.push(act)
      }
      if (this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '50') {
        act = { action: 5, label: 'Excluir NF' }
        this.moreActions.push(act)
      }

      if ((this.nf.stnf == '11' || this.nf.stnf == '01') && this.nf.flagarmazenada == 'S') {
        act = { action: 20, label: 'Excluir Armazenamento' }
        this.moreActions.push(act)
      }

      if ((this.nf.stnf == '01' || this.nf.stnf >= '11') && this.nf.flagestoquebaixado == 'S') {
        act = { action: 21, label: 'Excluir Baixa do Estoque' }
        this.moreActions.push(act)
      }

      if (this.nf.impxml == 'S' && (this.nf.stnf >= '11')) {
        act = { action: 6, label: 'Download do XML' }
        this.moreActions.push(act)
      }
      if (this.nf.emissaopropria == 'S' && this.nf.stnf == '11') {
        act = { action: 6, label: 'Download do XML' }
        this.moreActions.push(act)
        act = { action: 3, label: 'Cancelar NF-e' }
        this.moreActions.push(act)
      }
      if (this.nf.emissaopropria == 'S' && this.nf.stnf == '10') {
        act = { action: 2, label: 'Emitir Danfe PDF' }
        this.moreActions.push(act)
        act = { action: 1, label: 'Enviar Email da Danfe' }
        this.moreActions.push(act)
        act = { action: 0, label: '' }
        this.moreActions.push(act)
        act = { action: 8, label: 'Incluir Carta de Correção' }
        this.moreActions.push(act)
        act = { action: 30, label: 'Eventos NF-e' }
        this.moreActions.push(act)
        //falta checar: somente quando houver evento autorizado
        if (this.nf.nfev && this.nf.nfev.length > 0) {
          act = { action: 9, label: 'Gerar PDF da Carta Correção' }
          this.moreActions.push(act)
          act = { action: 10, label: 'Enviar Email da Carta de Correção' }
          this.moreActions.push(act)
        }
        act = { action: 3, label: 'Cancelar NF-e' }
        this.moreActions.push(act)
        //
        // act = { action: 4, label: 'Duplicar Nota Fiscal' }
        // this.moreActions.push(act)
      }
      if (this.nf.emissaopropria == 'S' && this.nf.stnf == '01') {
        act = { action: 7, label: 'Autorizar NF-e' }
        this.moreActions.push(act)
      }

      if (this.nf.emitecobranca == 'S') {
        act = { action: 12, label: 'Enviar Cobrança' }
        this.moreActions.push(act)
      }

      if ((this.nf.stnf == '00' || this.nf.stnf == '01' || this.nf.stnf == '02' || this.nf.stnf == '10' || this.nf.stnf == '50') || (this.nf.emissaopropria != 'S' && (this.nf.stnf >= '11'))) {
        act = { action: 22, label: 'Informar Chave e protocolo Manualmente' }
        this.moreActions.push(act)
      }

    },

    PDFResponseCallbackSAT(response) {
      //CALLBACK QUANDO A NF É ENVIADA POR CERTIFICADO SAT
      if (response.status != 'success') {
        this.$erpToastError(response.message)
      }

    },

    imprimirDANFE(preview) {
      //impressao da danfe em PDF
      let vm = this
      if (preview) {
        this.apiInvoice().then(function () {
          apiDownloadPDF(vm, 'print/previewdanfe/' + vm.nf.codnf)
        })
      } else if (this.nf.esp == '59') {
        let paramsimp = '&codnf=' + this.nf.codnf
        this.$executaExtensaoChromeSAT(this.nf.codnf, 'imp', this.PDFResponseCallbackSAT, paramsimp)
        return
      } else {
        apiDownloadPDF(this, 'print/danfe/' + this.nf.codnf)
      }
    },

    imprimirCC() {
      //impressao da cce em PDF
      apiDownloadPDF(this, 'print/cce/' + this.nf.codnf)
    },

    downloadXML() {
      //visualizacao do XML da NFE
      var data = { codnf: this.nf.codnf, chave: this.nf.chave, tipo: 'NFE' }
      apiDownload(this, 'print/xmlnfe/', data, 'post')
    },

    getDescricaoEvento(tpevento) {
      const descricoes = {
        '110110': 'Carta de Correção',
        '110111': 'Cancelamento',
        '110001': 'Cancelamento de Evento',
        '112110': 'Efetivo Pagamento Integral (IBS/CBS)',
        '112120': 'Importação ALC/ZFM não convertida em isenção',
        '112130': 'Perecimento, Deterioração ou Furto (Operação CIF)',
        '112140': 'Fornecimento Não Realizado',
        '112150': 'Atualização da Data de Previsão de Entrega',
        '211110': 'Solicitação de Apropriação de Crédito Presumido',
        '211124': 'Perecimento, Deterioração ou Furto (Operação FOB)',
        '211128': 'Aceite de Débito de Apuração (IBS/CBS)',
        '211130': 'Imobilização de Item',
        '211140': 'Solicitação de Apropriação de Crédito de Combustível',
        '211150': 'Solicitação de Apropriação de Crédito por Atividade',
        '212110': 'Manifestação de Transferência de Crédito IBS',
        '212120': 'Manifestação de Transferência de Crédito CBS'
      };
      return descricoes[tpevento] || 'Evento Outros (' + tpevento + ')';
    },

    async downloadXmlEvento(ev, tipo) {
      this.$appLoading(true);
      const url = `${this.$store.getters.urlOrds}invoice/evento/xml?codnf=${this.nf.codnf}&tpeventonfe=${ev.tpeventonfe}&seqevento=${ev.seqevento}&tipo=${tipo}`;

      try {
        const response = await this.$http.get(url);
        const xmlContent = response.data.items && response.data.items[0] ? response.data.items[0].xml : null;

        if (!xmlContent) {
          this.$erpToastError('O arquivo XML solicitado está vazio ou não foi encontrado.');
          return;
        }

        const file = new Blob([xmlContent], { type: 'application/xml' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(file);
        link.download = `evento_${ev.tpeventonfe}_${tipo}.xml`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$erpToastSuccess('Download iniciado com sucesso.');
      } catch (error) {
        this.$erpToastError('Erro ao baixar o XML do evento.');
        console.error('Download Event XML error:', error);
      } finally {
        this.$appLoading(false);
      }
    },

    handleEmitirEvento() {
      this.defaultTpEvento = '';
      this.defaultTpEventoAut = '';
      this.defaultNProtEvento = '';
      this.showEventos = true;
    },

    handleCancelarEvento(ev) {
      this.defaultTpEvento = '110001';
      this.defaultTpEventoAut = ev.tpeventonfe;
      this.defaultNProtEvento = ev.nprot;
      this.showEventos = true;
    },

    isEventoCancelado(ev) {
      if (!this.nf || !this.nf.nfev) return false;
      return this.nf.nfev.some(item => item.tpeventonfe === '110001' && item.nprotevento === ev.nprot);
    },

    handleFormEmailDanfe() {
      //Abre a tela para envio de email
      //carrega o template da mensagem antes do envio (ords/webdata/template/danfe/:id)
      this.showFormEmail = true
    },

    handleFormEmailCC() {
      //Abre a tela para envio de email
      //carrega o template da mensagem antes do envio (ords/webdata/template/danfe/:id)
      this.showFormEmailCC = true
    },

    closeFormEmail() {
      this.showFormEmail = false
      this.showFormEmailCC = false
    },

    async handleSendEmail(data) {
      //cahamda para envio de email da danfe
      this.closeFormEmail()
      let sendData = data
      sendData.codnf = this.nf.codnf
      sendData.chave = this.nf.chave
      sendData.tipo = 'DANFE'
      await apiEmailPDF(this, 'danfe/', sendData)
    },

    async handleSendEmailCC(data) {
      //cahamda para envio de email da danfe
      this.closeFormEmail()
      let sendData = data
      sendData.codnf = this.nf.codnf
      sendData.chave = this.nf.chave
      sendData.tipo = 'CCE'
      await apiEmailPDF(this, 'danfe/', sendData)
    },

    updateCepEnt() {
      //CARREGA INFORMACOES DO CEP DE ENTREGA
      this.nf.endeent = SysVars.endereco.logradouro
      this.nf.bairroent = SysVars.endereco.bairro
      this.nf.codmunent = SysVars.endereco.ibge
      this.nf.ufent = SysVars.endereco.uf
      if (this.nf.ufent && this.nf.ufent != 'EX')
        this.nf.codpaisent = '1058'
    },

    updateCepRet() {
      //CARREGA INFORMACOES DO CEP DE RETIRADA
      this.nf.enderet = SysVars.endereco.logradouro
      this.nf.bairroret = SysVars.endereco.bairro
      this.nf.codmunret = SysVars.endereco.ibge
      this.nf.ufret = SysVars.endereco.uf
      if (this.nf.ufret && this.nf.ufret != 'EX')
        this.nf.codpaisret = '1058'
    },

    handleEnderecoEntrega() {
      this.enderecoEntrega = true
    },

    handleEnderecoRetirada() {
      this.enderecoRetirada = true
    },

    handleExcluirEndereco(tipo) {
      //limpa o endereco de entrega ou retirada
      if (tipo == 'ent') {
        this.enderecoEntrega = false
        this.nf.tppessoaent = null
        this.nf.cnpjcpfent = null
        this.nf.cepent = null
        this.nf.endeent = null
        this.nf.endenrent = null
        this.nf.endecompent = null
        this.nf.bairroent = null
        this.nf.codmunent = null
        this.nf.ufent = null
      } else {
        this.enderecoRetirada = false
        this.nf.tppessoaret = null
        this.nf.cnpjcpfret = null
        this.nf.cepret = null
        this.nf.enderet = null
        this.nf.endenrret = null
        this.nf.endecompret = null
        this.nf.bairroret = null
        this.nf.codmunret = null
        this.nf.ufret = null
      }
    },

    async loadData() {
      this.textocorrecao_anterior = ''

      this.unwatch = true
      //carrega a nf para alteracao ou visualizacao
      await this.$store.dispatch('loadNf', { id: this.codnf })
      if (this.$store.getters.getNf) {
        this.nf = { ...this.$store.getters.getNf[0] }
        this.nfit = this.nf.nfit
        if (this.nf.parcelas || this.nf.parcelas == 0) {
          this.parcelas = this.nf.parcelas
        }
        if (this.nf.nfpar) {
          this.nfpar = this.nf.nfpar
        }
        if (this.nf.nfref) {
          this.nfref = this.nf.nfref
        }
        if (this.nfErro()) {
        } else {
          this.errmessages = []
        }
        this.moreActions = []
        this.updateActions()
        //carrega o texto da ultima correcao efetuada se houver
        let nfev = this.nf.nfev
        for (let i = 0; i < nfev.length; i++) {
          if (nfev[i].tpeventonfe != 'C') {
            this.textocorrecao_anterior = nfev[i].texto
          }
        }
      }
      this.nfOutrasNotas = (this.nf.operacaonf == 'E' || this.nf.venda != 'S')
      this.nfVendaLivre = this.nf.venda && (this.nfit.length == 0 || !this.nfit.codpedv)
      this.enderecoEntrega = (this.nf.cepent != null)
      this.enderecoRetirada = (this.nf.cepret != null)

      this.$nextTick(function () {
        jQuery('[data-toggle="tooltip"]').tooltip()
        this.unwatch = false
      })

    },

    changeTab(idx) {
      //mudança de pagina
      this._nf = this.nf
      this.activeTab = idx
    },

    handleValidaParcelas() {
      let isValid = true
      for (var x = 0; x <= this.nfpar.length - 1; x++) {
        if (x > 0 && stringToInteger(this.nfpar[x].dias) <= stringToInteger(this.nfpar[x - 1].dias)) {
          this.nfpar[x].error = 'Vencimento deve ser superior ao da parcela anterior'
          isValid = false
          //   this.$set(this.nfpar[x], 'error', 'Vencimento deve ser superior ao da parcela anterior')
        }
        else
          this.nfpar[x].error = null
      }
      return isValid
    },

    nfparDiasChange(index) {
      //evento de controle de alteracao do nr de dias de vencimento da parcela
      this.nfpar[index].dtv = this.$addDays(this.nf.data, this.nfpar[index].dias)
      this.handleValidaParcelas()
    },

    nfparDtvChange(index) {
      //recalcula o nr de dias ao alterar a data
      this.nfpar[index].dias = this.$daysBetween(this.nf.data, this.nfpar[index].dtv);
      this.handleValidaParcelas()
    },

    nfparVlrChange(index) {
      //evento de controle de alteracao do valor da parcela
      //quando usuario alterar o valor de uma parcela, refaz as demais parcelas
      if (this.nf.parcelas <= 1) {
        return
      }
      let vlrparcial = 0
      let vlrnovaparcela = 0
      for (var x = 0; x <= index; x++) {
        vlrparcial = vlrparcial + parseFloat(this.nfpar[x].vlr)
      }
      if (vlrparcial < this.nf.totger) {
        vlrnovaparcela = (this.nf.totger - vlrparcial) / (this.nf.parcelas - (index + 1))
        vlrnovaparcela.toFixed(2)
      }
      for (var x = index + 1; x <= this.nfpar.length - 1; x++) {
        this.nfpar[x].vlr = vlrnovaparcela
      }

    },

    async incluiNotaFiscalDemo() {
      //ROTINA QUE INCLUI UMA NOTA FISCAL DEMONSTRACAO COM 1 PRODUTO DE DEMONSTRACAO
      //ACESSO ATRAVÉS DO GUIA DA NFE
      let self = this
      apiORDS(this.$store.getters.urlOrds + 'cg/dadosdemonstracao', null, true).then((result) => {
        if (result.codpart && result.coditem) {
          self.dadosNotaFiscalDemo = result
          self.nf.codpart = result.codpart
          self.notaFiscalDemo = true
        }
      })
    },

    async incluiProdutoNotaFiscalDemo() {
      //INCLUI UM PRODUTO DEMO NA NOTA FISCAL
      this.nfit_update = { ...this.$store.getters.getEntities.nfit }
      this.nfit_update.finalidade = this.nf.finalidade
      this.nfit_update.codnf = this.nf.codnf
      this.nfit_update.pcredsn = this.nf.pcredsn

      this.nfit_update.coditem = this.dadosNotaFiscalDemo.coditem //296

      await this.apiCarregaProduto(this.nfit_update)
      this.nfit_update.qt = 1
      this.nfit_update.vlr = 100
      this.apiItens(this.nfit_update)

      this.$nextTick(function () {
        if (this.$refs.incluirProduto) {
          this.$refs.incluirProduto.focus()
        }
      })
    },

  },

  async mounted() {
    if (this.formIncluir) {
      if (this.nf.operacaonf == 'E') {
        const isValid = await apiValidaLimitePlano(this, 'nfentrada')
        if (!isValid)
          this.closeForm()
      } else {
        // let params = { operacao: this.operacaonf, filter: null }
        // await this.$store.dispatch('loadNfList', params)
        // this.hasManyNfs = (this.$store.getters.getNfList.length >= 1)
        // console.log(this.hasManyNfs)
        // if (this.showGuia && !this.hasManyNfs) {
        //   var tourguide = new Tourguide({
        //     steps: this.steps
        //   });

        //   tourguide.start();
        // }
      }

      const storedBannerIBSCBS = localStorage.getItem('nfsaida-form-banner-ibscbs')
      if (!storedBannerIBSCBS) {
        this.modalBannerIBSCBS = true
      }


      this.$nextTick(function () {
        if (this.$refs.organizacao)
          this.$refs.organizacao.focus()
      })
    }
  },



  async created() {
    this.metadata.nf.parcelas.options.sort(function (a, b) { return (Number(a.id) > Number(b.id)) ? 1 : ((Number(b.id) > Number(a.id)) ? -1 : 0); })

    this.ambienteHomologacaoNFe() //api-nfe

    this.$nextTick(function () {
      jQuery('[data-toggle="tooltip"]').tooltip()
    })

    //this.crudText = this.$crudText(this.crud)

    this.formIncluir = this.crud == SysVars.crudI
    let operacao = 'S'

    if (this.params) {
      //THIS.PARAMS QUANDO A CHAMADA É FEITA PELA LISTA DE NOTAS
      operacao = this.params.operacaoNf
      this.nfVendaLivre = this.params.vendaLivre
      this.nfVendaNfce = this.params.vendaNfce
      if (!this.nfVendaLivre)
        this.nfOutrasNotas = this.params.outrasSaidas
      this.entradaArmazenamento = this.params.entradaArmazenamento
      console.log(this.entradaArmazenamento)
    }
    else
      if (this.$route.params && this.$route.params.id == 'novo') {
        //inclusao de nota pelo guianfe ou pelo painel de nfe
        this.formIncluir = true
        if (this.$route.query.tipo == 'outras')
          this.nfOutrasNotas = true
        else
          if (this.$route.query.tipo == 'entrada') {
            this.nfOutrasNotas = true
            operacao = 'E'
          }
          else
            this.nfVendaLivre = true
      }
      else
        if (this.$route.params && this.$route.params.id) {
          if (this.$route.query.tipo == 'view') {
            this.codnf = this.$route.params.id
          }
          else if (this.$route.query.tipo == 'devolucao') {
            this.codnf = this.$route.params.id
          } else {
            if (this.$route.query.tipo == 'entrada') {
              this.nfOutrasNotas = true
              operacao = 'E'
              this.codcompra = this.$route.params.id
              this.handleCompra() //fatura o pedido
              this.formNF = true
            }else{
              //faturamento de pedido de venda
              this.codpedv = this.$route.params.id
              this.handleFaturar() //fatura o pedido
              this.formNF = true

            }

         }
        }

    if (this.formIncluir) {  //se for uma inclusao
      this.unwatch = false
      if (operacao == 'E') {
        this.nf.emissaopropria = 'N'
        this.nf.operacaonf = 'E'
        this.nf.tpfrete = '9'
        this.nfOutrasNotas = true
        this.nf.dtent = this.$getDate()
        if (this.entradaArmazenamento) {
          this.nf.entradaarmazenamento = 'S'
        }
        console.log(this.nf.entradaarmazenamento)

      } else {
        this.nf.emissaopropria = 'S'
        this.nf.operacaonf = 'S'
        this.nf.tpfrete = '9'
        // this.nf.dtsai = this.$getDate() //solicitado para retirar
        if (this.nfVendaLivre) {
          this.nf.venda = 'S'
        }
        if (this.nfVendaNfce) {
          this.nf.nfce = 'S'
        }


      }
    } else {
      //carrega a nf para alteracao/visualizacao
      if (!this.codnf)
        this.codnf = this.params.codnf
      this.loadData()
      this.view = this.crud == SysVars.crudView
      this.formNF = true
    }

    if ((this.showGuia) && !(this.nf.operacaonf == 'E')) {
      let params = { operacao: this.operacaonf, filter: null }
      await this.$store.dispatch('loadNfList', params)
      this.hasManyNfs = (this.$store.getters.getNfList.length >= 1)
      if (this.showGuia && !this.hasManyNfs) {
        var tourguide = new Tourguide({
          steps: this.steps
        });

        tourguide.start();
      }
    }



    if (this.$route.query.tipo == 'demo')
      this.incluiNotaFiscalDemo()

    this.$scrollTo(0)

  }

}

</script>

<template>
  <!-- <transition name="fade" mode="out-in" :duration="{ enter: 1000, leave: 1500 }"> -->
  <div>
    <!-- BARRA FIXA DE BOTOES INFERIOR -->
    <div v-if="!formIncluir && nfit.length" class="w-100 text-center"
      style="position: fixed; left: 0; bottom: 0; z-index: 10; border-top: 1px solid #eee; background-color: #fdfbfb; padding: 15px; -webkit-box-shadow: 0 -2px 5px rgba(0,0,0,0.2); -moz-box-shadow: 0 -2px 5px rgba(0,0,0,0.2); box-shadow: 0 -2px 5px rgba(0,0,0,0.2);">
      <v-button v-show="nf.stnf == '00'" label="Totalizar" title="" icon="fa-dollar" :nb-btdef="true"
        @click="handleTotalizar" v-if="!isView"></v-button>
      <v-button label="Salvar e Fechar" v-if="nf.stnf === '01' || nf.stnf === '50'" title="" :nb-btdef="true"
        @click="handleTotalizar(true)"></v-button>
      <!-- <v-button label="Salvar" v-if="(nf.stnf === '50')" title="" :nb-btdef="true" @click="handleTotalizar(false)"></v-button> -->
      <v-button label="Visualizar Pré Nota" v-if="(nfAguardando)" @click="handleActions(11)"></v-button>
      <v-button v-if="entradaArmazenamentoPendente" label="Armazenar Nota" title="" icon=""
        @click="handleArmazenarEntrada"></v-button>
      <v-button v-if="saidaEstoquePendente" label="Baixar Estoque" title="" icon="" @click="handleEstoqueSaida">
      </v-button>
      <v-button label="Autorizar" v-if="nfAguardando" icon="fa-rss-square" @click="handleActions(7)"></v-button>
      <v-button label="Danfe" v-if="nfAutorizada" @click="handleActions(2)"></v-button>
      <v-button label="Enviar E-mail" v-if="nfAutorizada" icon="fa-envelope-open" @click="handleActions(1)"></v-button>
    </div>
    <!-- FIM BARRA FIXA DE BOTOES INFERIOR -->


    <div v-if="formIncluir">
      <!-- CAMPOS INICIAIS PARA INCLUIR NOTA FISCAL  -->

      <div class="default-container mt-2">
        <div class="row align-items-center">
          <div class="col-md-6 col-12">
            <h4 class="def-title">Incluir Nota Fiscal</h4>
          </div>
          <div class="col-md-6 col-12">
            <v-button label="Continuar" title="" :nb-btdef="true" class="float-right" @click="handleIncluir"></v-button>
            <v-button label="Retornar" title="" icon="fa-arrow-left" class="float-right" @click="handleRetorna">
            </v-button>
          </div>
        </div>

        <div class="row mt-2">
          <div class="col">
            <!-- MENSAGENS DE ERRO E VALIDACAO DA NF -->
            <validation v-if="errmessages.errmessages" title="Erros de Validação" :messages="errmessages.errmessages">
            </validation>
            <!-- FIM MENSAGENS DE ERRO E VALIDACAO DA NF -->
          </div>
        </div>

        <label-title :title="titleParticipante" icon="fa-university"></label-title>
        <div class="row">
          <div class="col-md-6 col-12">
            <input-part ref="organizacao" v-model="nf.codpart" :participante="true" :add-button="true" id="part"
              name="Cliente/Fornecedor" :v-errors="errors" v-validate="metadata.nf.codpart.validator"></input-part>
          </div>
        </div>
        <div class="mt-3" v-if="nf.operacaonf == 'E'">
          <div class="row">
            <form-field v-model="nf.emissaopropria" type="select" col="2" :metadata="metadata.nf.emissaopropria"
              name="emissaopropria" :v-errors="errors" v-validate="metadata.nf.emissaopropria.validator"></form-field>
            <form-field v-model="nf.data" type="date" col="2" :metadata="metadata.nf.data" name="data"
              :v-errors="errors" v-validate="metadata.nf.data.validator"></form-field>
            <form-field v-model="nf.dtent" type="date" col="2" :metadata="metadata.nf.dtent" name="dtent"
              :v-errors="errors" v-validate="metadata.nf.dtent.validator"></form-field>
            <form-field v-if="nf.emissaopropria == 'N' && nf.entradaarmazenamento != 'S'" v-model="nf.serie" type="number" col="2"
              :metadata="metadata.nf.serie" name="serie" :v-errors="errors" v-validate="metadata.nf.serie.validator">
            </form-field>
            <form-field v-if="nf.emissaopropria == 'N' && nf.entradaarmazenamento != 'S'" v-model="nf.nf" type="number" col="2" :metadata="metadata.nf.nf"
              name="nf" :v-errors="errors" v-validate="metadata.nf.nf.validator"></form-field>
          </div>
          <div class="row">
            <form-field v-if="nf.emissaopropria == 'N' && nf.entradaarmazenamento != 'S'" v-model="nf.chave" type="text" col="6"
              :metadata="metadata.nf.chave" name="chave" :v-errors="errors" v-validate="metadata.nf.chave.validator">
            </form-field>
          </div>
          <div class="row" v-if="nf.entradaarmazenamento != 'S'" >
            <!-- NATUREZA ENTRADA -->
            <form-field v-model="nf.codnates" type="select2" col="6" :metadata="metadata.nf.codnates" :add-button="true"
              @clickAdd="handleIncluirNates()" name="codnates" id="codnates" :v-errors="errors"
              v-validate="metadata.nf.codnates.validator" :select2="{ entity: 'nates/entrada', minlength: 0 }">
            </form-field>
            <div class="w-100"></div>
            <form-field v-model="nf.cfop" type="select2" col="6" :metadata="metadata.nf.cfop" name="cfop" id="cfop"
              :v-errors="errors" v-validate="metadata.nf.cfop.validator"
              :select2="{ entity: 'cfop/entradas', minlength: 0 }"></form-field>
          </div>
          <div class="row" v-if="nf.operacaonf == 'E' && nf.entradaarmazenamento != 'S' && (nf.tpnf === 'CR' || nf.tpnf === 'DB')">
            <form-field v-if="nf.tpnf === 'CR'" v-model="nf.tpnfcredito" type="select" col="3" :metadata="metadata.nf.tpnfcredito" name="tpnfcredito" :v-errors="errors" v-validate="'required'"></form-field>
            <form-field v-if="nf.tpnf === 'DB'" v-model="nf.tpnfdebito" type="select" col="3" :metadata="metadata.nf.tpnfdebito" name="tpnfdebito" :v-errors="errors" v-validate="'required'"></form-field>
          </div>
        </div>
        <div class="mt-3" v-else>
          <div class="row">
            <form-field v-model="nf.dtsai" type="date" col="2" :metadata="metadata.nf.dtsai" name="dtsai"
              :v-errors="errors" v-validate="metadata.nf.dtsai.validator"></form-field>
          </div>
          <div class="row">
            <!-- NATUREZA DE VENDA -->
            <form-field v-show="nfVendaLivre" v-model="nf.codnates" type="select2" col="6"
              :metadata="metadata.nf.codnates" :add-button="true" @clickAdd="handleIncluirNates()" name="codnates"
              id="codnates" :v-errors="errors" v-validate="metadata.nf.codnates.validator"
              :select2="{ entity: 'nates/venda', minlength: 0 }"></form-field>
            <div class="w-100"></div>

            <!-- NATUREZA SAIDA -->
            <form-field v-show="!nfVendaLivre" v-model="nf.codnates" type="select2" col="6"
              :metadata="metadata.nf.codnates" :add-button="true" @clickAdd="handleIncluirNates()" name="codnotes"
              id="codnates" :v-errors="errors" v-validate="metadata.nf.codnates.validator"
              :select2="{ entity: 'nates/saida/outras', minlength: 0 }"></form-field>
            <div class="w-100"></div>
            <form-field v-model="nf.cfop" type="select2" col="6" :metadata="metadata.nf.cfop" name="cfop" id="cfop"
              :v-errors="errors" v-validate="metadata.nf.cfop.validator"
              :select2="{ entity: 'cfop/saidas', minlength: 0 }"></form-field>
          </div>
          <div class="row" v-if="nfVendaLivre">
            <form-field v-model="nf.finalidade" type="select" col="3" :metadata="metadata.nf.finalidade"></form-field>
            <form-field v-if="nf.tpnf === 'CR'" v-model="nf.tpnfcredito" type="select" col="3" :metadata="metadata.nf.tpnfcredito" name="tpnfcredito" :v-errors="errors" v-validate="'required'"></form-field>
            <form-field v-if="nf.tpnf === 'DB'" v-model="nf.tpnfdebito" type="select" col="3" :metadata="metadata.nf.tpnfdebito" name="tpnfdebito" :v-errors="errors" v-validate="'required'"></form-field>
          </div>
          <div class="row" v-if="!nfVendaLivre && (nf.tpnf === 'CR' || nf.tpnf === 'DB')">
            <form-field v-if="nf.tpnf === 'CR'" v-model="nf.tpnfcredito" type="select" col="3" :metadata="metadata.nf.tpnfcredito" name="tpnfcredito" :v-errors="errors" v-validate="'required'"></form-field>
            <form-field v-if="nf.tpnf === 'DB'" v-model="nf.tpnfdebito" type="select" col="3" :metadata="metadata.nf.tpnfdebito" name="tpnfdebito" :v-errors="errors" v-validate="'required'"></form-field>
          </div>
        </div>

        <!-- NOTAS DE INDUSTRIALIZACAO PERMITE INFORMAR NATUREZA DE RETORNO -->
        <div class="row">
          <form-field v-show="possuiNForigem()" v-model="nf.codnatesret" type="select2" col="4"
            :metadata="metadata.nf.codnatesret" :select2="{ entity: 'nates/saida/retorno', minlength: 0 }"></form-field>
        </div>

        <div class="row mb-2">
        </div>

        <!-- NOTAS REFERENCIADAS - USUARIO DIGITA INFORMAÇÕES -->
        <nf-form-ref v-if="showNfRef()" :nfref="nfref" :nf="nf"></nf-form-ref>
      </div>

    </div>


    <!-- FORMULARIO PRINCIPAL DA NF -->
    <div id="formNF" v-show="formNF">
      <div class="default-container mt-2">
        <!-- BARRA SUPERIOR DE TITULOS E BOTOES -->
        <div class="row mb-2">
          <div class="col-md-6 col-12">
            <h4 class="def-title"> {{ title }} <span v-if="nf.esp == '65'"
                class="badge badge-blue mr-2">NFC-e</span><span v-if="nf.esp == '59'"
                class="badge badge-blue mr-2">SAT</span></h4>
          </div>
          <div class="col-md-6 col-12">
            <div class="float-right">
              <v-button label="Retornar" title="" icon="fa-arrow-left" @click="handleRetorna"></v-button>
              <v-button v-show="nf.stnf == '11' && nf.flagarmazenada != 'S'" label="Editar" title="Editar nota fiscal"
                icon="fa-pencil" :nb-btdef="true" @click="handleEditar"></v-button>
              <v-button v-show="moreActions.length > 0" label="Mais Ações" @click="handleActions"
                :actions="moreActions"></v-button>
            </div>
          </div>
        </div>
        <div v-if="nf.entradaarmazenamento != 'S'"  class="row mb-2 align-items-center" style="background-color: #f9f9f9">
          <div class="col">
            <v-label label="Série"></v-label>
            <span class="lbl-total-documento" style="font-size: 24px; padding: 5px; background-color: #f9f9f9">{{
                nf.serie
            }}</span>
            <v-label label="Número"></v-label>
            <span class="lbl-total-documento" style="font-size: 24px; padding: 5px; background-color: #f9f9f9">{{ nf.nf
            }}</span>
            <a v-if="_alteraNumero" class="w-100" style="cursor: pointer; color: #0091ea;"
              @click="handleUpdateNumero"><i class="fa fa-pencil" aria-hidden="true"></i> Alterar numeração desta
              nota</a>
          </div>
          <div class="col text-right">
            <span v-if="nf.stnf == '00'" class="badge badge-orange mr-2">{{ nf.stnf | getTextOption(metadata.nf.stnf)
            }}</span>
            <span v-if="nf.stnf == '01' || nf.stnf == '02'" class="badge badge-blue mr-2">{{ nf.stnf | getTextOption(metadata.nf.stnf)
            }}</span>
            <span v-if="nf.stnf == '10' || nf.stnf == '11'" class="badge badge-green mr-2">{{ nf.stnf |
                getTextOption(metadata.nf.stnf)
            }}</span>
            <span v-if="nf.stnf >= '50'" class="badge badge-red mr-2">{{ nf.stnf | getTextOption(metadata.nf.stnf)
            }}</span>
            <span v-if="nf.emissaopropria == 'S'" class="badge badge-yellow mr-2">Nota Fiscal Própria</span>
            <span v-if="nf.carta_correcao > 0" class="badge badge-yellow mr-2">Carta de Correção</span>
            <!-- <span v-if="ambienteNFe" class="badge badge-red">NF-e em ambiente de homologação</span> -->
          </div>
        </div>

        <!-- dados da nf -->
        <div class="row align-items-center">
          <div class="col-md-4 col-6 d-flex align-items-center">
            <v-label :metadata-field="metadata.nf.data"></v-label>
            <strong class="">{{ nf.data | formatData }}</strong>
          </div>
          <div class="col-md-4 col-6 d-flex align-items-center">
            <v-label :metadata-field="metadata.nf.datalancamento"></v-label>
            <strong class="">{{ nf.datalancamento | formatData }}</strong>
          </div>
          <div class="col-md-4 col-6 d-flex align-items-center" v-if="nf.operacaonf != 'E'">
            <v-label :metadata-field="metadata.nf.dtsai"></v-label>
            <strong class="">{{ this.nf.dtsai | formatData }}</strong>
          </div>
          <div class="col-md-4 col-6 d-flex align-items-center" v-else>
            <v-label :metadata-field="metadata.nf.dtent"></v-label>
            <strong class="">{{ this.nf.dtent | formatData }}</strong>
          </div>
          <div class="col-md-4 col-6 d-flex align-items-center" v-if="nf.nates">
            <v-label :metadata-field="metadata.nf.codnates"></v-label>
            <strong class=""> {{ selectedNates.descricao }} </strong>
          </div>
          <div class="col-md-4 col-6 d-flex align-items-center">
            <v-label :metadata-field="metadata.nf.finalidade"></v-label>
            <div class="">{{ nf.finalidade | getTextOption(metadata.nf.finalidade) }}</div>
          </div>
          <div class="col-md-4 col-6 d-flex align-items-center" v-if="nf.tpnf === 'CR'">
            <v-label :metadata-field="metadata.nf.tpnfcredito"></v-label>
            <div class="">{{ nf.tpnfcredito | getTextOption(metadata.nf.tpnfcredito) }}</div>
          </div>
          <div class="col-md-4 col-6 d-flex align-items-center" v-if="nf.tpnf === 'DB'">
            <v-label :metadata-field="metadata.nf.tpnfdebito"></v-label>
            <div class="">{{ nf.tpnfdebito | getTextOption(metadata.nf.tpnfdebito) }}</div>
          </div>
          <div v-if="nf.xmotivo && nf.stnf != '10'" class="col-6 error"> {{ nf.xmotivo }} </div>
          <div class="col-md-4 col-3 d-flex align-items-center my-2" v-if="nf.npedido">
            <v-label :metadata-field="metadata.pedv.npedido"></v-label>
            <div class="">{{ nf.npedido }}</div>
          </div>
        </div>
        <hr>
        <label-title :title="titleParticipante" icon="fa-university"></label-title>
        <div class="row col mb-2">
          <input-part ref="part" :participante="true"
            :disabled="(isView || nf.codpedv || (this.nf.flagarmazenada == 'S') || (this.nf.flagestoquebaixado == 'S'))"
            :showMsgEmail="(nf.operacaonf != 'E')" v-model="nf.codpart"></input-part>
        </div>
        <!-- MENSAGENS DE ERRO E VALIDACAO DA NF -->
        <validation v-if="errmessages.errmessages" title="Erros de Validação" :messages="errmessages.errmessages">
        </validation>
        <!-- FIM MENSAGENS DE ERRO E VALIDACAO DA NF -->
        <div v-if="nf.fin_baixado">
          <alert type="info" title="Aviso" text="Esta nota fiscal possui títulos baixados."></alert>
        </div>

        <div v-if="nfPossuiEvento">
          <alert type="info" title="Aviso" text="Esta nota fiscal possui eventos vinculados."></alert>
        </div>

        <div v-if="entradaArmazenamentoPendente">
          <alert type="info" :text="entradaArmazenamentoPendente"></alert>
        </div>

        <div v-if="entradaArmazenamentoConcluido">
          <alert type="info" title="Aviso" :text="entradaArmazenamentoConcluido"></alert>
        </div>

        <div v-if="saidaEstoquePendente">
          <alert type="info" :text="saidaEstoquePendente"></alert>
        </div>

        <div v-if="saidaEstoqueBaixado">
          <alert type="info" title="Aviso" :text="saidaEstoqueBaixado"></alert>
        </div>

        <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab"></tabs>
      </div>

      <div v-if="this.nfref.length > 0" class="default-container nb-margin-top" style="border-top: 3px solid black">
        <div class="row col">
          <label-title title="Notas Fiscais Referenciadas" icon="fa-info-circle"></label-title>
          <a v-if="!isView" class="ml-3 mt-3" style="cursor: pointer; color: #0091ea;"
            @click="editNfRef = !editNfRef"><i class="fa fa-pencil" aria-hidden="true" data-toggle="tooltip"
              data-placement="top" title="Alterar dados"></i></a>
        </div>
        <div v-show="!editNfRef">
          <div class="mainbox" v-for="nf in nfref" v-bind:key="nf.itref">
            <div class="mark-gray"></div>
            <div class="box">
              <div class="row align-items-center">
                <div class="col-md-5 col-3">
                  <v-label :metadata-field="metadata.nf.chave"></v-label><br>
                  <span class="data-list w-100">{{ nf.chave }}</span>
                </div>
                <div class="col-md-2 col-3" v-if="nf.serie">
                  <v-label :metadata-field="metadata.nf.serie"></v-label><br>
                  <span class="data-list w-100">{{ nf.serie }}</span>
                </div>
                <div class="col-md-2 col-3" v-if="nf.nf">
                  <v-label :metadata-field="metadata.nf.nf"></v-label><br>
                  <span class="data-list w-100">{{ nf.nf }}</span>
                </div>
                <div class="col-md-3 col-3 d-flex align-items-center justify-content-end pr-4" v-if="isNfRefLinked(nf)">
                  <span class="badge badge-green p-2" style="font-size: 0.85rem;">
                    <i class="fa fa-link"></i> Vinculada ao Item
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-show="editNfRef">
          <nf-form-ref v-if="showNfRef()" :nfref="nfref" :nf="nf" :title="false"></nf-form-ref>
        </div>
      </div>

      <div class="default-container nb-margin-top" style="border-top: 3px solid black">
        <!-- LISTA DE ITENS DA NOTA FISCAL -->
        <div v-show="activeTab == 0">
          <label-title :title="'Produtos (' + nfit.length + ')'" icon="fa-archive"></label-title>
          <!-- <alert v-if="!nfit.length" type="info" text="Esta nota fiscal ainda não possui itens."></alert> -->
          <div class="row col" v-if="habilitaBotaoProduto">
            <!-- botão inclusão de itens para outras notas -->
            <v-button ref="incluirProduto" label="Incluir Produto" title="" :nb-btdef="true" icon="fa-plus"
              @click="handleIncluirItem" @keydown.enter="handleIncluirItem"></v-button>
          </div>
          <div>
            <div class="mainbox" v-for="(it, index) in nfit" :key="index">
              <div class="mark-gray"></div>
              <div class="box pl-3">
                <div class="row">
                  <div class="col-md-12 col-6 row">
                    <div class="col-md-6 col-auto">
                      <span class="lbl-title-produto w-100">{{ it.item[0].descricao }}</span>
                      <v-label class="d-none d-md-inline" label="Seq"></v-label>
                      <span class="lbl d-none d-md-inline">{{ it.itnf }}</span>
                      <v-label class="" label="Codigo"></v-label>
                      <span class="lbl break-words text-break"
                        style="word-break: break-all !important; white-space: wrap !important;">{{ it.item[0].codigo
                        }}</span>
                      <v-label class="d-none d-md-inline" label="ST"></v-label>
                      <span class="data-list d-none d-md-inline"
                        v-if="it.sticm && (nf.filial[0].crt != 1) && (nf.filial[0].crt != 4)">{{ it.sticm
                        }}</span>
                      <span class="data-list d-none d-md-inline" v-else>{{ it.csosn }}</span>
                      <v-label class="d-none d-md-inline" label="CFOP"></v-label>
                      <span class="data-list d-none d-md-inline">{{ it.cfop }}</span>
                      <v-label class="d-none d-md-inline" label="% ICMS"></v-label>
                      <span class="data-list d-none d-md-inline">{{ it.aicm | formatValue(2) }}</span>
                      <v-label class="d-none d-md-inline" label="% ST"></v-label>
                      <span class="data-list d-none d-md-inline">{{ it.aicmst | formatValue(2) }}</span>
                      <v-label class="d-none d-md-inline" label="%IPI"></v-label>
                      <span class="data-list d-none d-md-inline">{{ it.aipi | formatValue(2) }}</span>
                      <v-label class="d-none d-md-inline" label="Regra" v-if="it.codregraimp"></v-label>
                      <span class="data-list d-none d-md-inline" v-if="it.codregraimp">{{ it.codregraimp }}</span>
                    </div>
                    <div class="col-md-2 col-auto">
                      <v-label :metadata-field="metadata.nfit.qtuni"></v-label>
                      <span class="data-list w-100">{{ it.qtuni }} {{ it.uni }}</span>
                    </div>
                    <div class="col-md-1 col-auto">
                      <v-label label="Preço"></v-label>
                      <span class="data-list w-100">{{ it.vlr | formatValue(2) }}</span>
                    </div>
                    <div class="col-md-2 col-auto d-none d-md-flex align-item-start order-last ml-md-auto">
                      <bar-grid :options="{ barDefault: true, btnView: true, btnEdit: editItem, btnDelete: deleteItem }"
                        :moreActions="{}" @edit="handleEditItem(it.itnf, false)" @view="handleEditItem(it.itnf, true)"
                        @delete="handleDeleteItemMsg(index)">
                      </bar-grid>
                    </div>
                  </div>
                  <div
                    class="col-6 d-flex d-md-none flex-wrap align-items-center justify-content-end order-last ml-md-auto">
                    <bar-grid :options="{ barDefault: true, btnView: false, btnEdit: editItem, btnDelete: deleteItem }"
                      :moreActions="{}" @edit="handleEditItem(it.itnf, false)" @delete="handleDeleteItemMsg(index)">
                    </bar-grid>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br>
          <div class="row" v-if="nfit.length">
            <div class="col-md-8 col-12">
              <div>
                <a style="cursor: pointer; color: #0091ea;" @click="showTotal = true">Detalhar Totais</a>
              </div>
              <div v-if="showTotal" class="dropdown-total col-md-8 col-12" style="padding: 15px">
                <button type="button" class="close" @click="showTotal = false"><span
                    aria-hidden="true">&times;</span></button>
                <div class="row col mb-2">
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.bcicm"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.bcicm | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.toticm"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.toticm | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.totfcp"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.totfcp | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.bcicmst"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.bcicmst | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.toticmst"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.toticmst | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.toticmdeson"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.toticmdeson | formatValue(2) }}</span>
                  </div>
                </div>

                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.totfcpst"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.totfcpst | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.totipi"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.totipi | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.totipidevol"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.totipidevol | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.toticmemit"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.toticmemit | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.toticmdest"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.toticmdest | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.totfcpdest"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.totfcpdest | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.bcpis"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.bcpis | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.totpis"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.totpis | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.totpisst"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.totpisst | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.bccofins"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.bccofins | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.totcofins"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.totcofins | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.totcofinsst"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.totcofinsst | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.vretirrf"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.vretirrf | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.vretcsll"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.vretcsll | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.vretinss"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.vretinss | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.vretpis"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.vretpis | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.vretcofins"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.vretcofins | formatValue(2) }}</span>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <v-label class="float-left" :metadata-field="metadata.nf.totii"></v-label>
                  </div>
                  <div class="col">
                    <span class="lbl float-right">R$ {{ nf.totii | formatValue(2) }}</span>
                  </div>
                </div>

              </div>
            </div>
            <div class="col-md-4 col-6">
              <table class="table table-sm" style="margin-left: 0; width: 100%;">
                <tbody>
                  <tr v-if="nf.totret">
                    <th>
                      <v-label :metadata-field="metadata.nf.totret"></v-label>
                    </th>
                    <th><span class="lbl float-right">{{ nf.totret | formatValue(2) }}</span></th>
                  </tr>

                  <tr>
                    <th>
                      <v-label :metadata-field="metadata.nf.totmer"></v-label>
                    </th>
                    <th><span class="lbl float-right">{{ nf.totmer | formatValue(2) }}</span></th>
                  </tr>
                  <tr v-if="nf.toticm">
                    <th>
                      <v-label :metadata-field="metadata.nf.toticm"></v-label>
                    </th>
                    <th><span class="lbl float-right">{{ nf.toticm | formatValue(2) }}</span></th>
                  </tr>
                  <tr v-if="_toticmsst">
                    <th>
                      <v-label :metadata-field="metadata.nf.toticmst"></v-label>
                    </th>
                    <th><span class="lbl float-right">{{ _toticmsst | formatValue(2) }}</span></th>
                  </tr>
                  <tr v-if="nf.totipi">
                    <th>
                      <v-label :metadata-field="metadata.nf.totipi"></v-label>
                    </th>
                    <th><span class="lbl float-right">{{ nf.totipi | formatValue(2) }}</span></th>
                  </tr>
                  <tr v-if="nf.totipidevol">
                    <th>
                      <v-label :metadata-field="metadata.nf.totipidevol"></v-label>
                    </th>
                    <th><span class="lbl float-right">{{ nf.totipidevol | formatValue(2) }}</span></th>
                  </tr>
                  <tr v-if="nf.vlrfre">
                    <th>
                      <v-label :metadata-field="metadata.nf.vlrfre"></v-label>
                    </th>
                    <th><span class="lbl float-right">{{ nf.vlrfre | formatValue(2) }}</span></th>
                  </tr>
                  <tr v-if="nf.vlrdesp">
                    <th>
                      <v-label :metadata-field="metadata.nf.vlrdesp"></v-label>
                    </th>
                    <th><span class="lbl float-right">{{ nf.vlrdesp | formatValue(2) }}</span></th>
                  </tr>
                  <tr v-if="nf.vlrseg">
                    <th>
                      <v-label :metadata-field="metadata.nf.vlrseg"></v-label>
                    </th>
                    <th><span class="lbl float-right">{{ nf.vlrseg | formatValue(2) }}</span></th>
                  </tr>
                  <tr v-if="nf.totdes">
                    <th>
                      <v-label :metadata-field="metadata.nf.totdes"></v-label>
                    </th>
                    <th><span class="lbl float-right">{{ nf.totdes | formatValue(2) }}</span></th>
                  </tr>
                  <tr v-if="nf.totdup">
                    <th>
                      <v-label :metadata-field="metadata.nf.totdup"></v-label>
                    </th>
                    <th><span class="lbl float-right">{{ nf.totdup | formatValue(2) }}</span></th>
                  </tr>
                  <tr>
                    <th>
                      <v-label :metadata-field="metadata.nf.totger"></v-label>
                    </th>
                    <th><span class="lbl-total-documento float-right">{{ nf.totger | formatValue(2) }}</span></th>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <!-- EVENTOS DA NOTA FISCAL -->
        <div v-show="activeTab == 1">

          <!-- PROTOCOLO DE CANCELAMENTO -->
          <div class="mainbox" v-if="nf.nfxml && nf.nfxml.length > 0 && nf.nfxml[0].nprotcan">
            <div class="mark-green"></div>
            <div class="box">
              <div class="row">
                <div class="col-md-2 col-3">
                  <v-label :metadata-field="metadata.nf.dtcan"></v-label><br>
                  <span class="data-list">{{ nf.dtcan | formatData }}</span>
                </div>
                <div class="col-md-3 col-6">
                  <v-label :metadata-field="metadata.nfxml.nprot"></v-label><br>
                  <span class="data-list">{{ nf.nfxml[0].nprotcan }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-12 col-12">
                  <v-label :metadata-field="metadata.nf.obscan"></v-label><br>
                  <span class="data-list">{{ nf.obscan }} </span>
                </div>
              </div>
            </div>
          </div>
          <!-- FIM PROTOCOLO DE CANCELAMENTO -->
          <br>
          <div v-if="!nfPossuiEvento">
            <alert type="info" title="Aviso" text="Esta nota fiscal ainda não possui eventos vinculados."></alert>
          </div>

          <!-- PROTOCOLOS DE EVENTOS -->
          <div class="mainbox" v-for="(ev, index) in nf.nfev" v-bind:key="index">
            <div class="mark-green"></div>
            <div class="box">
              <div class="row align-items-center">
                <div class="col-md-2 col-12">
                  <label>Data</label><br>
                  <span class="data-list">{{ ev.data | formatData }}</span>
                </div>
                <div class="col-md-2 col-12">
                  <label>Código do Evento</label><br>
                  <span class="data-list"><strong>{{ ev.tpeventonfe }}</strong></span>
                </div>
                <div class="col-md-3 col-12">
                  <label>Tipo do Evento</label><br>
                  <span class="data-list">{{ getDescricaoEvento(ev.tpeventonfe) }}</span>
                </div>
                <div class="col-md-2 col-12">
                  <label>Protocolo</label><br>
                  <span class="data-list">{{ ev.nprot }} </span>
                </div>
                <div class="col-md-1 col-12">
                  <span v-if="!isEventoCancelado(ev)" class="badge badge-success" style="background-color: #2e7d32; color: white; font-size: 0.75rem;">Autorizado</span>
                  <span v-else class="badge badge-danger" style="background-color: #c62828; color: white; font-size: 0.75rem;">Cancelado</span>
                </div>
                <div class="col-md-2 col-12 d-flex justify-content-end align-items-center">
                 <v-button
                    v-if="ev.tpeventonfe !== '110001' && ev.tpeventonfe !== '110111' && !isEventoCancelado(ev)"
                    label=""
                    icon="fa-trash"
                    class="btn-sm ml-2"
                    title="Cancelar este Evento na SEFAZ"
                    @click="handleCancelarEvento(ev)"
                  ></v-button>
                  <v-button
                    label=""
                    icon="fa-download"
                    class="btn-sm"
                    title="Baixar XML Protocolado"
                    @click="downloadXmlEvento(ev, 'PROT')"
                  ></v-button>
                </div>
              </div>
              <div class="row mt-2" v-if="ev.texto">
                <div class="col-md-12 col-12">
                  <label>Histórico / Justificativa</label><br>
                  <span class="data-list">{{ ev.texto }} </span>
                </div>
              </div>
              <div class="row mt-2" v-if="ev.tpeventonfe === '110001' && ev.tpeventoaut">
                <div class="col-md-12 col-12">
                  <span class="data-list" style="color: #c62828;">
                    <i class="fa fa-info-circle mr-1"></i>
                    <strong>Evento Original Cancelado:</strong> {{ ev.tpeventoaut }} - {{ getDescricaoEvento(ev.tpeventoaut) }}
                    <span class="mx-2">|</span>
                    <strong>Protocolo Original:</strong> {{ ev.nprotevento }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!-- FIM PROTOCOLOS DE EVENTOS -->
        </div>
        <!-- FIM EVENTOS DA NOTA FISCAL -->


      </div>

      <div class="default-container nb-margin-top" style="border-top: 3px solid black">
        <label-title title="Desconto"></label-title>
        <div class="row">
          <form-field v-model="nf.vlrdesc" type="value" col="2" :metadata="metadata.nf.vlrdesc"
            @input="handleChangeValores()" :disabled="isView" name="vlrdesc" :v-errors="errors"
            v-validate="metadata.nf.vlrdesc.validator"></form-field>
        </div>
        <!-- PARCELAS -->
        <div class="mb-b mt-2" v-if="habilitaDuplicata">
          <label-title title="Condição de Pagamento"></label-title>
          <div class="row">
            <form-field v-model="nf.codnatfin" type="select2" col="4" :metadata="metadata.nf.codnatfin"
              :disabled="isView" name="codnatfin" :v-errors="errors" v-validate="metadata.nf.codnatfin.validator"
              :select2="{ entity: (nf.operacaonf == 'E' ? 'natfin/despesas' : 'natfin/receitas'), minlength: 0 }"></form-field>
            <div class="col-md-2 col-12">
              <div class="form-group form-group-sm">
                <v-label :metadata-field="metadata.nf.parcelas"></v-label>
                <div class="input-group input-group-sm">
                  <select ref="parcelas" class="form-control" v-model="parcelas" :disabled="isView">
                    <option v-for="opt in metadata.nf.parcelas.options" :key="opt.id" :value="opt.id">{{ opt.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <!-- <form-field v-model="nf.icmstparc" type="select" col="2" :metadata="metadata.nf.icmstparc" :disabled="isView"
                            name="icmstparc" :v-errors="errors" v-validate="metadata.nf.icmstparc.validator"></form-field> -->
            <!-- <form-field v-model="nf.codportador" type="select2" col="2" :metadata="metadata.nf.codportador" :disabled="isView"
                            name="codportador" :v-errors="errors" v-validate="metadata.nf.codportador.validator"></form-field>
                        <form-field v-model="nf.codtpcob" type="select2" col="2" :metadata="metadata.nf.codtpcob" :disabled="isView"
                            name="codtpcob" :v-errors="errors" v-validate="metadata.nf.codtpcob.validator"></form-field> -->
            <div class="col-md-10" v-if="nfpar.length > 0">
              <div class="row justify-content-md-center">
                <div class="col-md-2 col-3">
                  <v-label :metadata-field="metadata.nfpar.dias"></v-label>
                </div>
                <div class="col-md-2 col-3">
                  <v-label :metadata-field="metadata.nfpar.dtv"></v-label>
                </div>
                <div class="col-md-2 col-3">
                  <v-label :metadata-field="metadata.nfpar.vlr"></v-label>
                </div>
                <!-- Forma de Pagamento -->
                <div class="col-md-3 col-3">
                  <v-label :metadata-field="metadata.nfpar.formapag"></v-label>
                </div>
              </div>
              <div class="row justify-content-md-center" v-for="(par, index) in nfpar" :key="index">
                <form-field class="mb-1" v-model="par.dias" type="number" col="2"
                  :disabled="isView || nf.parcelas === '0'" name="dias" :v-errors="errors"
                  v-validate="metadata.nfpar.dias.validator" @input="nfparDiasChange(index)"></form-field>
                <form-field class="mb-1" v-model="par.dtv" type="date" col="2" :disabled="isView" name="dtv"
                  :v-errors="errors" v-validate="metadata.nfpar.dtv.validator" @input="nfparDtvChange(index)">
                </form-field>
                <form-field class="mb-1" v-model="par.vlr" type="value" col="2" :precision="2" :disabled="isView"
                  name="vlr" :v-errors="errors" v-validate="metadata.nfpar.vlr.validator"
                  @input="nfparVlrChange(index)"></form-field>
                <!-- Forma de Pagamento -->
                <form-field v-model="par.formapag" type="select" col="3" :metadata="metadata.nfpar.formapag"
                  :disabled="isView" :nolabel="true" :optionnull="true"></form-field>

                <div class="w-100"></div>
                <div class="col-md-6 mt-n3 mb-2" v-if="par.error">
                  <small class="error">{{ par.error }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- FIM PARCELAS -->

        <label-title title="Transporte"></label-title>
        <div class="row">
          <form-field ref="tpfrete" v-model="nf.tpfrete" type="select" col="2" :metadata="metadata.nf.tpfrete"
            :disabled="isView" name="tpfrete" :v-errors="errors" v-validate="metadata.nf.tpfrete.validator">
          </form-field>
        </div>
        <div class="row" v-if="nf.tpfrete != '9'">
          <form-field v-model="nf.codparttr" type="select2" col="4" :metadata="metadata.nf.codparttr" name="codparttr"
            :v-errors="errors" v-validate="metadata.nf.codparttr.validator" :disabled="isView" :add-button="true"
            @clickAdd="handleIncluirPart(true)"></form-field>
          <form-field v-model="nf.placa" type="text" col="2" :metadata="metadata.nf.placa" :disabled="isView"
            name="placa" :v-errors="errors" v-validate="metadata.nf.placa.validator"></form-field>
          <form-field v-model="nf.placauf" type="text" col="2" :metadata="metadata.nf.placauf" :disabled="isView"
            name="placauf" :v-errors="errors" v-validate="metadata.nf.placauf.validator"></form-field>
          <form-field v-model="nf.rntc" type="text" col="2" :metadata="metadata.nf.rntc" :disabled="isView" name="rntc"
            :v-errors="errors" v-validate="metadata.nf.rntc.validator"></form-field>
        </div>
        <div class="row">
          <form-field v-model.number="nf.vlrfre" type="value" col="2" :metadata="metadata.nf.vlrfre"
            @input="handleChangeValores()" :disabled="isView" name="vlrfre" :v-errors="errors"
            v-validate="metadata.nf.vlrfre.validator"></form-field>
          <form-field v-model.number="nf.vlrseg" type="value" col="2" :metadata="metadata.nf.vlrseg"
            @input="handleChangeValores()" :disabled="isView" name="vlrseg" :v-errors="errors"
            v-validate="metadata.nf.vlrseg.validator"></form-field>
          <form-field v-model.number="nf.vlrdesp" type="value" col="2" :metadata="metadata.nf.vlrdesp"
            @input="handleChangeValores()" :disabled="isView" name="vlrdesp" :v-errors="errors"
            v-validate="metadata.nf.vlrdesp.validator"></form-field>
          <form-field v-model.number="nf.pliq" type="value" col="2" :metadata="metadata.nf.pliq" :disabled="isView"
            name="pliq" :v-errors="errors" v-validate="metadata.nf.pliq.validator"></form-field>
          <form-field v-model.number="nf.pbru" type="value" col="2" :metadata="metadata.nf.pbru" :disabled="isView"
            name="pbru" :v-errors="errors" v-validate="metadata.nf.pbru.validator"></form-field>
          <form-field v-model.number="nf.qtvolumes" type="value" col="2" :metadata="metadata.nf.qtvolumes"
            :disabled="isView" name="qtvolumes" :v-errors="errors" v-validate="metadata.nf.qtvolumes.validator">
          </form-field>
          <form-field v-model="nf.volespecie" type="text" col="2" :metadata="metadata.nf.volespecie" :disabled="isView"
            name="volespecie" :v-errors="errors" v-validate="metadata.nf.volespecie.validator"></form-field>
          <form-field v-model="nf.volmarca" type="text" col="2" :metadata="metadata.nf.volmarca" :disabled="isView"
            name="volmarca" :v-errors="errors" v-validate="metadata.nf.volmarca.validator"></form-field>
          <form-field v-model="nf.volnr" type="text" col="2" :metadata="metadata.nf.volnr" :disabled="isView"
            name="volnr" :v-errors="errors" v-validate="metadata.nf.volnr.validator"></form-field>
          <form-field v-model="nf.pedcli" type="text" col="2" :metadata="metadata.nf.pedcli" :disabled="isView"
            name="pedcli" :v-errors="errors" v-validate="metadata.nf.pedcli.validator"></form-field>


        </div>

        <label-title title="Informações Adicionais" icon="fa-info-circle"></label-title>
        <div class="row mt-2">
          <form-field v-model="codmenCpl" type="select2" col="6" :metadata="metadata.nf.obs" :disabled="isView"
            :select2="{ entity: 'mennf', minlength: 0 }"></form-field>
          <form-field v-model="codmenFisco" type="select2" col="6" :metadata="metadata.nf.obsfisco" :disabled="isView"
            :select2="{ entity: 'mennf', minlength: 0 }"></form-field>
        </div>
        <div class="row">
          <div class="col-md-6 col-12">
            <div class="form-group">
              <textarea rows="6" cols="100" class="form-control" name="obs" v-model="nf.obs"
                :disabled="isView"></textarea>
            </div>
          </div>
          <div class="col-md-6 col-12">
            <div class="form-group">
              <textarea rows="6" cols="100" class="form-control" name="obsfisco" v-model="nf.obsfisco"
                :disabled="isView"></textarea>
            </div>
          </div>
        </div>
        <div class="row" v-if="nf.obsauto">
          <div class="col-md-6 col-12">
            <div class="form-group">
              <span class="data-list"> {{ nf.obsauto }} </span>
            </div>
          </div>
          <!-- <div class="col-md-6 col-12">
                        <div class="form-group">
                            <span class="data-list"> {{ nf.obsfiscoauto }} </span>
                        </div>
                    </div> -->
        </div>

        <div class="row">
          <!-- <div class="col-md-4 col-6">
                        <v-label :metadata-field="metadata.nf.codparttr"></v-label>
                        <div class="lbl" v-if="nf.parttr && nf.parttr.length">{{ nf.parttr[0].nome }}</div>
                    </div>
                    <div class="col-md-4 col-6">
                        <v-label :metadata-field="metadata.nf.codvendr"></v-label>
                        <div class="lbl" v-if="nf.vendr && nf.vendr.length">{{ nf.vendr[0].nome }}</div>
                    </div>
                    <div class="col-md-4 col-6">
                        <v-label :metadata-field="metadata.nf.finalidade"></v-label>
                        <div class="lbl">{{ nf.finalidade | getTextOption(metadata.nf.finalidade) }}</div>
                    </div>
                    <div class="col-md-4 col-6" v-if="nf.tpnf === 'CR'">
                        <v-label :metadata-field="metadata.nf.tpnfcredito"></v-label>
                        <div class="lbl">{{ nf.tpnfcredito | getTextOption(metadata.nf.tpnfcredito) }}</div>
                    </div>
                    <div class="col-md-4 col-6" v-if="nf.tpnf === 'DB'">
                        <v-label :metadata-field="metadata.nf.tpnfdebito"></v-label>
                        <div class="lbl">{{ nf.tpnfdebito | getTextOption(metadata.nf.tpnfdebito) }}</div>
                    </div>
                    <div class="col-md-4 col-6">
                        <v-label :metadata-field="metadata.nf.qtvolumes"></v-label>
                        <div class="lbl">{{ nf.qtvolumes }}</div>
                    </div>
                    <div class="col-md-4 col-6">
                        <v-label :metadata-field="metadata.nf.volespecie"></v-label>
                        <div class="lbl">{{ nf.volespecie }}</div>
                    </div>
                    <div class="col-md-4 col-6">
                        <v-label :metadata-field="metadata.nf.volmarca"></v-label>
                        <div class="lbl">{{ nf.volmarca }}</div>
                    </div>
                    <div class="col-md-4 col-6">
                        <v-label :metadata-field="metadata.nf.pliq"></v-label>
                        <div class="lbl">{{ nf.pliq | formatValue(2) }}</div>
                    </div>
                    <div class="col-md-4 col-6">
                        <v-label :metadata-field="metadata.nf.pbru"></v-label>
                        <div class="lbl">{{ nf.pbru | formatValue(2) }}</div>
                    </div> -->
        </div>

        <div class="row">
          <div v-if="!showNewTaxes && !isView" class="ml-3 mt-2 mb-2">
            <a href="javascript:void(0);" :tabindex="1" @click="showNewTaxes = true">
              <i class="fa fa-caret-down" aria-hidden="true"></i> Exibir Nova Tributação (IS, IBS, CBS)
            </a>
          </div>

          <div class="col-12" v-if="showNewTaxes || isView">
            <label-title title="Impostos Unificados (IBS e CBS)"></label-title>
            <div class="row">
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.ibscbstotbc"></v-label>
                <div class="lbl">{{ nf.ibscbstotbc | formatValue(2) }}</div>
              </div>
            </div>

            <label-title title="IBS"></label-title>
            <div class="row">
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.ibstot"></v-label>
                <div class="lbl">{{ nf.ibstot | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.ibsuftot"></v-label>
                <div class="lbl">{{ nf.ibsuftot | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.ibsuftotdif"></v-label>
                <div class="lbl">{{ nf.ibsuftotdif | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.ibsuftotdevtrib"></v-label>
                <div class="lbl">{{ nf.ibsuftotdevtrib | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.ibsmuntot"></v-label>
                <div class="lbl">{{ nf.ibsmuntot | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.ibsmuntotdif"></v-label>
                <div class="lbl">{{ nf.ibsmuntotdif | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.ibsmuntotdevtrib"></v-label>
                <div class="lbl">{{ nf.ibsmuntotdevtrib | formatValue(2) }}</div>
              </div>
            </div>

            <label-title title="CBS"></label-title>
            <div class="row">
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.cbstot"></v-label>
                <div class="lbl">{{ nf.cbstot | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.cbstotdif"></v-label>
                <div class="lbl">{{ nf.cbstotdif | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.cbstotdevtrib"></v-label>
                <div class="lbl">{{ nf.cbstotdevtrib | formatValue(2) }}</div>
              </div>
            </div>

            <label-title title="Créditos Presumidos"></label-title>
            <div class="row">
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.ibstotpres"></v-label>
                <div class="lbl">{{ nf.ibstotpres | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.ibstotprescondsus"></v-label>
                <div class="lbl">{{ nf.ibstotprescondsus | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.cbstotpres"></v-label>
                <div class="lbl">{{ nf.cbstotpres | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.cbstotprescondsus"></v-label>
                <div class="lbl">{{ nf.cbstotprescondsus | formatValue(2) }}</div>
              </div>
            </div>

            <label-title title="Imposto Seletivo"></label-title>
            <div class="row">
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.istot"></v-label>
                <div class="lbl">{{ nf.istot | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.istotbc"></v-label>
                <div class="lbl">{{ nf.istotbc | formatValue(2) }}</div>
              </div>

            </div>

            <label-title title="Tributação Monofásica"></label-title>
            <div class="row">
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.ibstotmono"></v-label>
                <div class="lbl">{{ nf.ibstotmono | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.cbstotmono"></v-label>
                <div class="lbl">{{ nf.cbstotmono | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.ibstotmonoret"></v-label>
                <div class="lbl">{{ nf.ibstotmonoret | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.cbstotmonoret"></v-label>
                <div class="lbl">{{ nf.cbstotmonoret | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.ibstotmonoreten"></v-label>
                <div class="lbl">{{ nf.ibstotmonoreten | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.cbstotmonoreten"></v-label>
                <div class="lbl">{{ nf.cbstotmonoreten | formatValue(2) }}</div>
              </div>
            </div>

            <label-title title="Estorno de Crédito"></label-title>
            <div class="row">
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.ibstotestcred"></v-label>
                <div class="lbl">{{ nf.ibstotestcred | formatValue(2) }}</div>
              </div>
              <div class="col-md-4 col-6">
                <v-label :metadata-field="metadata.nf.cbstotestcred"></v-label>
                <div class="lbl">{{ nf.cbstotestcred | formatValue(2) }}</div>
              </div>
            </div>

          </div>
        </div>


        <div class="row col mt-2">
          <v-button label="Alterar Outras Informações" title="" icon="fa-pencil" :nb-btdef="true"
            @click="handleAlterarOutras"></v-button>
        </div>
        <div class="row mt-2">
          <div class="col-md-12 col-12" v-if="nf.enderet">
            <v-label class="w-100" :metadata-field="metadata.nf.enderet"></v-label>
            <div class="lbl">{{ nf.enderet }} {{ nf.endenrret }} {{ nf.bairroret }} {{ nf.ufret }}</div>
          </div>
          <div class="col-md-12 col-12" v-if="nf.endeent">
            <v-label class="w-100" :metadata-field="metadata.nf.endeent"></v-label>
            <div class="lbl">{{ nf.endeent }} {{ nf.endenrent }} {{ nf.bairroent }} {{ nf.ufent }}</div>
          </div>
        </div>
      </div>

    </div>
    <!-- formNF -->


    <div v-if="showFormItem">
      <Trap>
        <nfsaida-item :params="paramItem" @closeform="closeFormItem" @save="saveItem"></nfsaida-item>
      </Trap>
    </div>


    <!-- INFORMACOES COMPLEMENTARES -->
    <div v-if="formCab" class="nb-modal-scrollable">
      <Trap>
        <div id="mymodal" class="container nb-modal-scrollable-container">
          <div class="nb-modal-header">
            <h4 class="def-title"> Outras Informações </h4>
            <button type="button" class="close" @click="closeFormCab()" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="nb-modal-scrollable-body">
            <div class="row" v-if="nfOutrasNotas">
              <!-- <form-field v-if="nf.operacaonf=='S'" v-model="nf.codnates" type="select2" col="6" :metadata="metadata.nf.codnates"
                                    :select2="{entity: 'nates/saida/outras', minlength: 0}"></form-field>
                            <form-field v-if="nf.operacaonf=='E'" v-model="nf.codnates" type="select2" col="6" :metadata="metadata.nf.codnates"
                                    :select2="{entity: 'nates/entrada', minlength: 0}"></form-field>
                            <form-field v-model="nf.codpart" type="select2" col="6" :metadata="metadata.nf.codpart"
                                name="codpart" :v-errors="errors" v-validate="metadata.nf.codpart.validator"></form-field> -->
              <!-- :select2="{entity: 'cliente', minlength: 1}"></form-field> -->
            </div>

            <div class="row">
              <form-field v-if="nf.stnf == '10'" v-model="nf.chave" type="text" col="6" :metadata="metadata.nf.chave"
                :disabled="isView || nf.emissaopropria == 'S'" name="chave" :v-errors="errors"
                v-validate="metadata.nf.chave.validator"></form-field>
              <form-field v-if="nf.operacaonf == 'E'" v-model="nf.dtent" type="date" col="2"
                :metadata="metadata.nf.dtent" :disabled="isView" name="dtent" :v-errors="errors"
                v-validate="metadata.nf.dtent.validator"></form-field>
              <form-field v-if="nf.operacaonf == 'S'" v-model="nf.dtsai" type="date" col="2"
                :metadata="metadata.nf.dtsai" :disabled="isView" name="dtsai" :v-errors="errors"
                v-validate="metadata.nf.dtsai.validator"></form-field>
              <form-field v-model="nf.pedcli" type="text" col="2" :metadata="metadata.nf.pedcli" :disabled="isView"
                name="pedcli" :v-errors="errors" v-validate="metadata.nf.pedcli.validator"></form-field>
            </div>
            <div class="row">
              <form-field v-model="nf.finalidade" type="select" col="3"
                :metadata="metadata.nf.finalidade" :disabled="isView" name="finalidade" :v-errors="errors"
                v-validate="metadata.nf.finalidade.validator"></form-field>
              <form-field v-if="nf.tpnf === 'CR'" v-model="nf.tpnfcredito" type="select" col="3" :metadata="metadata.nf.tpnfcredito" :disabled="isView" name="tpnfcredito" :v-errors="errors" v-validate="'required'"></form-field>
              <form-field v-if="nf.tpnf === 'DB'" v-model="nf.tpnfdebito" type="select" col="3" :metadata="metadata.nf.tpnfdebito" :disabled="isView" name="tpnfdebito" :v-errors="errors" v-validate="'required'"></form-field>
              <form-field v-model="nf.indpresencial" type="select" col="3" :metadata="metadata.nf.indpresencial"
                :disabled="isView" name="indpresencial" :v-errors="errors"
                v-validate="metadata.nf.indpresencial.validator"></form-field>
              <form-field v-model="nf.indintermed" type="select" col="4" :metadata="metadata.nf.indintermed"
                :disabled="isView"
                v-if="nf.indpresencial == '2' || nf.indpresencial == '3' || nf.indpresencial == '4' || nf.indpresencial == '9'">
              </form-field>
              <form-field v-model="nf.movfisica" type="select" col="3" :metadata="metadata.nf.movfisica"
                :disabled="isView" name="movfisica" :v-errors="errors" v-validate="metadata.nf.movfisica.validator">
              </form-field>
              <!-- <form-field v-model="nf.iest" type="text" col="3" :metadata="metadata.nf.iest" :disabled="isView"
                                name="iest" :v-errors="errors" v-validate="metadata.nf.iest.validator"></form-field> -->
            </div>
            <div class="row">
              <!-- <form-field v-model="nf.calcdesicm" type="select" col="3" :metadata="metadata.nf.calcdesicm" :disabled="true"
                                name="calcdesicm" :v-errors="errors" v-validate="metadata.nf.calcdesicm.validator"></form-field>
                <form-field v-model="nf.calcdespc" type="select" col="3" :metadata="metadata.nf.calcdespc" :disabled="true"
                    name="calcdespc" :v-errors="errors" v-validate="metadata.nf.calcdespc.validator"></form-field> -->
              <form-field v-model="nf.movterc" type="select" col="3" :metadata="metadata.nf.movterc" :disabled="true"
                name="movterc" :v-errors="errors" v-validate="metadata.nf.movterc.validator"></form-field>
              <form-field v-model="nf.movest" type="select" col="3" :metadata="metadata.nf.movest" :optionnull="false"
                :disabled="isView || (nf.stnf != '00' && nf.stnf != '01') || nf.flagestoquebaixado == 'S' || !controleEstoqueHabilitado"
                name="movest" :v-errors="errors" v-validate="metadata.nf.movest.validator"></form-field>
            </div>

            <!-- transporte -->
            <label-title title="Transporte" class="mt-3"></label-title>
            <div class="row">
              <form-field v-model="nf.tpfrete" type="select" col="2" :metadata="metadata.nf.tpfrete" :disabled="isView"
                name="tpfrete" :v-errors="errors" v-validate="metadata.nf.tpfrete.validator"></form-field>
            </div>
            <!-- <div class="row" v-if="nf.tpfrete != '9'"> -->
            <div class="row">
              <form-field v-model="nf.codparttr" type="select2" col="4" :metadata="metadata.nf.codparttr"
                name="codparttr" :v-errors="errors" v-validate="metadata.nf.codparttr.validator" :disabled="isView"
                :add-button="true" @clickAdd="handleIncluirPart(true)"></form-field>
              <form-field v-model="nf.placa" type="text" col="2" :metadata="metadata.nf.placa" :disabled="isView"
                name="placa" :v-errors="errors" v-validate="metadata.nf.placa.validator"></form-field>
              <form-field v-model="nf.placauf" type="text" col="2" :metadata="metadata.nf.placauf" :disabled="isView"
                name="placauf" :v-errors="errors" v-validate="metadata.nf.placauf.validator"></form-field>
              <form-field v-model="nf.rntc" type="text" col="2" :metadata="metadata.nf.rntc" :disabled="isView"
                name="rntc" :v-errors="errors" v-validate="metadata.nf.rntc.validator"></form-field>
            </div>
            <div class="row">
              <form-field v-model.number="nf.vlrdesc" type="value" col="2" :metadata="metadata.nf.vlrdesc"
                :disabled="isView" name="vlrdesc" :v-errors="errors" v-validate="metadata.nf.vlrdesc.validator">
              </form-field>
              <form-field v-model.number="nf.vlrfre" type="value" col="2" :metadata="metadata.nf.vlrfre"
                :disabled="isView" name="vlrfre" :v-errors="errors" v-validate="metadata.nf.vlrfre.validator">
              </form-field>
              <form-field v-model.number="nf.vlrseg" type="value" col="2" :metadata="metadata.nf.vlrseg"
                :disabled="isView" name="vlrseg" :v-errors="errors" v-validate="metadata.nf.vlrseg.validator">
              </form-field>
              <form-field v-model.number="nf.vlrdesp" type="value" col="2" :metadata="metadata.nf.vlrdesp"
                :disabled="isView" name="vlrdesp" :v-errors="errors" v-validate="metadata.nf.vlrdesp.validator">
              </form-field>
              <form-field v-model.number="nf.pliq" type="value" col="2" :metadata="metadata.nf.pliq" :disabled="isView"
                name="pliq" :v-errors="errors" v-validate="metadata.nf.pliq.validator"></form-field>
              <form-field v-model.number="nf.pbru" type="value" col="2" :metadata="metadata.nf.pbru" :disabled="isView"
                name="pbru" :v-errors="errors" v-validate="metadata.nf.pbru.validator"></form-field>
              <form-field v-model.number="nf.qtvolumes" type="value" col="2" :metadata="metadata.nf.qtvolumes"
                :disabled="isView" name="qtvolumes" :v-errors="errors" v-validate="metadata.nf.qtvolumes.validator">
              </form-field>
            </div>
            <div class="row">
              <form-field v-model="nf.volespecie" type="text" col="4" :metadata="metadata.nf.volespecie"
                :disabled="isView" name="volespecie" :v-errors="errors" v-validate="metadata.nf.volespecie.validator">
              </form-field>
              <form-field v-model="nf.volmarca" type="text" col="4" :metadata="metadata.nf.volmarca" :disabled="isView"
                name="volmarca" :v-errors="errors" v-validate="metadata.nf.volmarca.validator"></form-field>
              <form-field v-model="nf.volnr" type="text" col="4" :metadata="metadata.nf.volnr" :disabled="isView"
                name="volnr" :v-errors="errors" v-validate="metadata.nf.volnr.validator"></form-field>

            </div>
            <label-title v-if="nfExportacao" title="Exportação" class="mt-5"></label-title>
            <div class="row" v-if="nfExportacao">
              <form-field v-model="nf.ufsaidapais" type="select2" col="4" :metadata="metadata.nf.ufsaidapais"
                name="ufsaidapais" :v-errors="errors" v-validate="metadata.nf.ufsaidapais.validator"></form-field>
              <form-field v-model="nf.localemb" type="text" col="4" :metadata="metadata.nf.localemb" name="localemb"
                :v-errors="errors" v-validate="metadata.nf.localemb.validator"></form-field>
              <form-field v-model="nf.localdesp" type="text" col="4" :metadata="metadata.nf.localdesp" name="localdesp"
                :v-errors="errors" v-validate="metadata.nf.localdesp.validator"></form-field>
            </div>
            <label-title v-if="nfImportacao" title="Importação" class="mt-5"></label-title>
            <div class="row" v-if="nfImportacao">
              <form-field v-model="nf.numerodi" type="text" col="2" :metadata="metadata.nf.numerodi" name="numerodi"
                :v-errors="errors" v-validate="metadata.nf.numerodi.validator"></form-field>
              <form-field v-model="nf.datadi" type="date" col="2" :metadata="metadata.nf.datadi" name="datadi"
                :v-errors="errors" v-validate="metadata.nf.datadi.validator"></form-field>
              <form-field v-model="nf.datadesemb" type="date" col="2" :metadata="metadata.nf.datadesemb"
                name="datadesemb" :v-errors="errors" v-validate="metadata.nf.datadesemb.validator"></form-field>
              <form-field v-model="nf.localdesemb" type="text" col="4" :metadata="metadata.nf.localdesemb"
                name="localdesemb" :v-errors="errors" v-validate="metadata.nf.localdesemb.validator"></form-field>
              <form-field v-model="nf.ufdesemb" type="select2" col="4" :metadata="metadata.nf.ufdesemb" name="ufdesemb"
                :v-errors="errors" v-validate="metadata.nf.ufdesemb.validator"></form-field>
              <form-field v-model="nf.viatranspdi" type="select" col="3" :metadata="metadata.nf.viatranspdi"
                name="viatranspdi" :v-errors="errors" v-validate="metadata.nf.viatranspdi.validator"></form-field>
              <form-field v-model="nf.vafrmm" type="value" col="2" :metadata="metadata.nf.vafrmm" name="vafrmm"
                :v-errors="errors" v-validate="metadata.nf.vafrmm.validator"></form-field>
              <form-field v-model="nf.tpintermediodi" type="select" col="3" :metadata="metadata.nf.tpintermediodi"
                name="tpintermediodi" :v-errors="errors" v-validate="metadata.nf.tpintermediodi.validator"></form-field>
            </div>
            <div class="row" v-if="nfImportacao && (nf.tpintermediodi == '2' || nf.tpintermediodi == '3')">
              <form-field v-model="nf.cnpjadquirente" type="cnpj" col="2" :metadata="metadata.nf.cnpjadquirente"
                name="cnpjadquirente" :v-errors="errors" v-validate="metadata.nf.cnpjadquirente.validator"></form-field>
              <form-field v-model="nf.ufadquirente" type="select2" col="4" :metadata="metadata.nf.ufadquirente"
                name="ufadquirente" :v-errors="errors" v-validate="metadata.nf.ufadquirente.validator"></form-field>
            </div>
            <br>
            <div class="row" v-if="!isView">
              <div class="col-md-12 col-12">
                <v-button label="Definir Local de Entrega" title="" :nb-btdef="true" v-if="!enderecoEntrega"
                  @click="handleEnderecoEntrega"></v-button>
                <v-button label="Definir Local de Retirada" title="" :nb-btdef="true" v-if="!enderecoRetirada"
                  @click="handleEnderecoRetirada"></v-button>
              </div>
            </div>


            <div id="entrega" v-if="enderecoRetirada">
              <label-title title="Endereço de Retirada" class="mt-2"></label-title><br>
              <div class="row mb-2" v-if="!isView">
                <div class="col-md-12 col-12">
                  <v-button label="Excluir Endereço" title="" :nb-btdef="true" @click="handleExcluirEndereco('ret')">
                  </v-button>
                </div>
              </div>
              <div class="row">
                <form-field v-model="nf.tppessoaret" type="select" col="2" :metadata="metadata.nf.tppessoaret"
                  name="tppessoaret" :v-errors="errors" v-validate="metadata.nf.tppessoaret.validator"></form-field>
                <form-field v-if="nf.tppessoaret == 'J'" v-model="nf.cnpjcpfret" type="text" col="3"
                  :metadata="metadata.nf.cnpjcpfret" name="cnpjcpfret" :v-errors="errors"
                  v-validate="{ cnpj: true, required: true,  min: 14, max: 14 }"></form-field>
                <form-field v-if="nf.tppessoaret == 'F'" v-model="nf.cnpjcpfret" type="text" col="3"
                  :metadata="metadata.nf.cnpjcpfret" name="cnpjcpfret" :v-errors="errors"
                  v-validate="{ cpf: true, required: true,  min: 11, max: 11 }"></form-field>
                <div class="w-100"></div>
                <form-field v-model="nf.nomeret" type="text" col="6" :metadata="metadata.nf.nomeret" :disabled="isView"
                  name="nomeret" :v-errors="errors" v-validate="metadata.nf.nomeret.validator"></form-field>
                <form-field v-model="nf.emailret" type="email" col="4" :metadata="metadata.nf.emailret"
                  :disabled="isView" name="emailret" :v-errors="errors" v-validate="metadata.nf.emailret.validator">
                </form-field>
                <form-field v-model="nf.foneret" type="fone" col="2" :metadata="metadata.nf.foneret" :disabled="isView"
                  name="foneret" :v-errors="errors" v-validate="metadata.nf.foneret.validator"></form-field>
                <div class="w-100"></div>
                <form-field v-model="nf.cepret" type="cep" col="2" :metadata="metadata.nf.cepret" name="cepret"
                  :v-errors="errors" v-validate="metadata.nf.cepret.validator" @update="updateCepRet"></form-field>
                <form-field v-model="nf.enderet" type="text" col="4" :metadata="metadata.nf.enderet" name="enderet"
                  :v-errors="errors" v-validate="metadata.nf.enderet.validator"></form-field>
                <form-field v-model="nf.endenrret" type="text" col="2" :metadata="metadata.nf.endenrret"
                  name="endenrret" :v-errors="errors" v-validate="metadata.nf.endenrret.validator"></form-field>
                <form-field v-model="nf.endecompret" type="text" col="4" :metadata="metadata.nf.endecompret"
                  name="endecompret" :v-errors="errors" v-validate="metadata.nf.endecompret.validator"></form-field>
                <form-field v-model="nf.bairroret" type="text" col="4" :metadata="metadata.nf.bairroret"
                  name="bairroret" :v-errors="errors" v-validate="metadata.nf.bairroret.validator"></form-field>
                <form-field v-model="nf.ufret" type="select2" col="4" :metadata="metadata.nf.ufret" name="ufret"
                  :v-errors="errors" v-validate="metadata.nf.ufret.validator"></form-field>
                <form-field v-model="nf.codmunret" type="select2" col="4" :metadata="metadata.nf.codmunret"
                  name="codmunret" :v-errors="errors" v-validate="metadata.nf.codmunret.validator"
                  :select2="{ entity: 'mun/uf/' + nf.ufret, minlength: 2 }"></form-field>
                <form-field v-model="nf.codpaisret" type="select2" col="3" :metadata="metadata.nf.codpaisret"
                  name="codpaisret" :v-errors="errors" v-validate="metadata.nf.codpaisret.validator"></form-field>
              </div>
            </div>

            <div id="entrega" v-if="enderecoEntrega">
              <label-title title="Endereço de Entrega" class="mt-2"></label-title>
              <div class="row mb-2" v-if="!isView">
                <div class="col-md-12 col-12">
                  <v-button label="Excluir Endereço" title="" :nb-btdef="true" @click="handleExcluirEndereco('ent')">
                  </v-button>
                </div>
              </div>
              <div class="row">
                <form-field v-model="nf.tppessoaent" type="select" col="2" :metadata="metadata.nf.tppessoaent"
                  name="tppessoaent" :v-errors="errors" v-validate="metadata.nf.tppessoaent.validator"></form-field>
                <form-field v-if="nf.tppessoaent == 'F'" v-model="nf.cnpjcpfent" type="text" col="2"
                  :metadata="metadata.nf.cnpjcpfent" name="cpfent" :v-errors="errors"
                  v-validate="{ cpf: true, required: true,  min: 11, max: 11 }"></form-field>
                <form-field v-if="nf.tppessoaent == 'J'" v-model="nf.cnpjcpfent" type="text" col="2"
                  :metadata="metadata.nf.cnpjcpfent" name="cnpjent" :v-errors="errors"
                  v-validate="{ cnpj: true, required: true,  min: 14, max: 14 }"></form-field>
                <div class="w-100"></div>
                <form-field v-model="nf.nomeent" type="text" col="6" :metadata="metadata.nf.nomeent" :disabled="isView"
                  name="nomeent" :v-errors="errors" v-validate="metadata.nf.nomeent.validator"></form-field>
                <form-field v-model="nf.emailent" type="email" col="4" :metadata="metadata.nf.emailent"
                  :disabled="isView" name="emailent" :v-errors="errors" v-validate="metadata.nf.emailent.validator">
                </form-field>
                <form-field v-model="nf.foneent" type="fone" col="2" :metadata="metadata.nf.foneent" :disabled="isView"
                  name="foneent" :v-errors="errors" v-validate="metadata.nf.foneent.validator"></form-field>
                <div class="w-100"></div>
                <form-field v-model="nf.cepent" type="cep" col="2" :metadata="metadata.nf.cepent" name="cepent"
                  :v-errors="errors" v-validate="metadata.nf.cepent.validator" @update="updateCepEnt"></form-field>
                <form-field v-model="nf.endeent" type="text" col="4" :metadata="metadata.nf.endeent" name="endeent"
                  :v-errors="errors" v-validate="metadata.nf.endeent.validator"></form-field>
                <form-field v-model="nf.endenrent" type="text" col="2" :metadata="metadata.nf.endenrent"
                  name="endenrent" :v-errors="errors" v-validate="metadata.nf.endenrent.validator"></form-field>
                <form-field v-model="nf.endecompent" type="text" col="4" :metadata="metadata.nf.endecompent"
                  name="endecompent" :v-errors="errors" v-validate="metadata.nf.endecompent.validator"></form-field>
                <form-field v-model="nf.bairroent" type="text" col="4" :metadata="metadata.nf.bairroent"
                  name="bairroent" :v-errors="errors" v-validate="metadata.nf.bairroent.validator"></form-field>
                <form-field v-model="nf.ufent" type="select2" col="4" :metadata="metadata.nf.ufent" name="ufent"
                  :v-errors="errors" v-validate="metadata.nf.ufent.validator"></form-field>
                <form-field v-model="nf.codmunent" type="select2" col="4" :metadata="metadata.nf.codmunent"
                  name="codmunent" :v-errors="errors" v-validate="metadata.nf.codmunent.validator"
                  :select2="{ entity: 'mun/uf/' + nf.ufent, minlength: 2 }"></form-field>
                <form-field v-model="nf.codpaisent" type="select2" col="3" :metadata="metadata.nf.codpaisent"
                  name="codpaisent" :v-errors="errors" v-validate="metadata.nf.codpaisent.validator"></form-field>
              </div>
            </div>
            <div class="mt-5" v-if="selectedNates && selectedNates.calcdup == 'S'">
              <label-title title="Retenção de Impostos" class="mt-2"></label-title>
              <div class="row">
                <form-field v-model="nf.calcreten" type="select" col="2" :metadata="metadata.nf.calcreten"
                  :disabled="isView" name="calcreten" :v-errors="errors" v-validate="metadata.nf.calcreten.validator">
                </form-field>
              </div>
              <div class="row" v-if="nf.calcreten == 'S'">
                <form-field v-model="nf.pretcsll" type="value" col="2" :metadata="metadata.nf.pretcsll"
                  :disabled="isView" name="pretcsll" :v-errors="errors" v-validate="metadata.nf.pretcsll.validator"
                  addon="%"></form-field>
                <form-field v-model="nf.pretpis" type="value" col="2" :metadata="metadata.nf.pretpis" :disabled="isView"
                  name="pretpis" :v-errors="errors" v-validate="metadata.nf.pretpis.validator" addon="%"></form-field>
                <form-field v-model="nf.pretcofins" type="value" col="2" :metadata="metadata.nf.pretcofins"
                  :disabled="isView" name="pretcofins" :v-errors="errors" v-validate="metadata.nf.pretcofins.validator"
                  addon="%"></form-field>
                <form-field v-model="nf.pretinss" type="value" col="2" :metadata="metadata.nf.pretinss"
                  :disabled="isView" name="pretinss" :v-errors="errors" v-validate="metadata.nf.pretinss.validator"
                  addon="%"></form-field>
                <form-field v-model="nf.pretirrf" type="value" col="2" :metadata="metadata.nf.pretirrf"
                  :disabled="isView" name="pretirrf" :v-errors="errors" v-validate="metadata.nf.pretirrf.validator"
                  addon="%"></form-field>
              </div>
            </div>
            <div class="mt-5" v-if="selectedPart && selectedPart.tpentgov != ''">
              <label-title title="Compra Governamental" class="mt-2"></label-title>
              <div class="row">
                <form-field v-model="nf.tpopergov" type="select" col="2" :metadata="metadata.nf.tpopergov"
                  :disabled="isView" name="tpopergov" :v-errors="errors" v-validate="metadata.nf.tpopergov.validator">
                </form-field>
              </div>
              <div class="row">
                <form-field v-model="nf.predutorgov" type="value" col="2" :metadata="metadata.nf.predutorgov"
                  :disabled="isView" name="predutorgov" :v-errors="errors"
                  v-validate="metadata.nf.predutorgov.validator" addon="%"></form-field>
              </div>
            </div>


            <div class="nb-modal-scrollable-footer mt-2">
              <v-button v-if="!isView" ref="btnConfirm" label="Salvar" title="" :nb-btdef="true"
                @click="handleSalvarDadosAdicionais"></v-button>
              <v-button ref="btnClose" label="Cancelar" title="" @click="closeFormCab"></v-button>
            </div>
          </div>
        </div>
      </Trap>
    </div>
    <!-- formCab -->




    <!-- MENSAGEM PARA EXCLUSAO DE ITEM -->
    <md-message v-if="DELETE_ITEM_MESSAGE" code="deleteit" @close="handleCloseMessage()" @confirm="handleDeleteItem()">
    </md-message>


    <!-- ALTERACAO DO NUMERO DA NF -->
    <nf-form-numero v-if="showNumeroForm" :nf="nf" @closeform="closeNumeroForm" @save="updateNumero"></nf-form-numero>


    <!-- ARMAZENAMENTO DA NOTA DE ENTRADA -->
    <div class="nb-modal-scrollable" v-if="showFormEstoqueEntrada">
      <div class="nb-modal-scrollable-container" style="padding: 15px; width: 90%">
        <div class="nb-modal-scrollable-body">
          <estoque-entrada :index="nf.codnf" :excluir="excluirArmazenamento" @closeform="closeEstoqueForm">
          </estoque-entrada>
        </div>
      </div>
    </div>


    <!-- ARMAZENAMENTO DA NOTA DE SAIDA -->
    <div class="nb-modal-scrollable" v-if="showEstoqueSaida">
      <div class="nb-modal-scrollable-container" style="padding: 15px; width: 90%">
        <div class="nb-modal-scrollable-body">
          <estoque-saida :index="nf.codnf" :excluir="excluirEstoqueSaida" :notafiscal="true"
            @closeform="closeEstoqueForm"></estoque-saida>
        </div>
      </div>
    </div>


    <!-- CADASTRO DO CLIENTE  -->
    <div class="nb-modal-scrollable" v-if="showPartForm">
      <div class="nb-modal-scrollable-container" style="padding: 15px; width: 80%">
        <div class="nb-modal-scrollable-body">
          <customer-form :crud="crudPart" :index="codpart" @closeform="closeCustomerForm"></customer-form>
        </div>
      </div>
    </div>

    <!-- CADASTRO DE NATUREZA -->
    <div class="nb-modal-scrollable" v-if="showNatesForm">
      <Trap>
        <div class="container nb-modal-scrollable-container">
          <div class="nb-modal-scrollable-body">
            <nates-form crud="ins" @closeform="closeNatesForm"></nates-form>
          </div>
        </div>
      </Trap>
    </div>

    <div class="nb-modal-scrollable" v-if="showModalNfxml">
      <Trap>
        <div class="container">
          <div class="nb-modal-scrollable-body">
            <nfsaida-modal-nfxml v-if="showModalNfxml" class="to-front" @close="closeModalNfxml()"
              @getNfxml="handleInformaNfxml($event)" :nf="nf" />
          </div>
        </div>
      </Trap>
    </div>



    <!-- CARTA DE CORRECAO -->
    <div class="nb-modal-mask" v-if="showCorrecao">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="def-title" id="exampleModalLabel"> Carta de Correção </h4>
          </div>
          <div class="modal-body" style="max-height: 255px; overflow-y: auto">
            <!-- MENSAGENS DE ERRO E VALIDACAO DA NF -->
            <div v-if="errCorrecao.length != 0">
              <div class="col">
                <div class="alert alert-danger fade show" role="alert">
                  <h5 class="alert-heading">Erro ao enviar a carta de correção: </h5>
                  <p v-for="(err, index) in errCorrecao" :key="index">
                    <small>{{ err }}</small>
                  </p>
                </div>
              </div>
            </div>
            <!-- FIM MENSAGENS DE ERRO E VALIDACAO DA NF -->
            <div class="row" v-if="textocorrecao_anterior != ''">
              <div class="col-md-12 col-12">
                <div class="form-group">
                  <textarea rows="5" cols="100" class="form-control" v-model="textocorrecao_anterior"
                    disabled></textarea>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-12">
                <label class="lbl">Informe o texto da correção:</label>
                <div class="form-group">
                  <textarea rows="5" cols="100" class="form-control" v-model="textocorrecao" ref="correcao"></textarea>
                  <label class="lbl">O texto da correção deve possuir no mínimo 15 e no máximo 1000 caracteres</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <v-button label="Enviar Correção" title="" :nb-btdef="true" icon="fa-check" @click="handleCorrecao">
            </v-button>
            <v-button label="Descartar" title="" icon="fa-rotate-left" @click="handleCorrecaoClose"></v-button>
          </div>
        </div>
      </div>
    </div>
    <!-- FIM CARTA DE CORRECAO -->

    <nfe-eventos-form
      v-if="showEventos"
      :nf="nf"
      :default-tp-evento="defaultTpEvento"
      :default-tp-evento-aut="defaultTpEventoAut"
      :default-n-prot-evento="defaultNProtEvento"
      @close="showEventos = false"
      @success="loadData"
    ></nfe-eventos-form>


    <!-- JUSTIFICATIVA DO CANCELAMENTO -->
    <div class="nb-modal-mask" v-if="showCancel">
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="def-title" id="exampleModalLabel">Cancelamento de Nota Fiscal</h4>
          </div>
          <div class="modal-body" style="max-height: 255px; overflow-y: auto">
            <!-- MENSAGENS DE ERRO E VALIDACAO DA NF -->
            <div v-if="errCorrecao.length != 0">
              <div class="col">
                <div class="alert alert-danger fade show" role="alert">
                  <h5 class="alert-heading">Erro ao enviar pedido de cancelamento: </h5>
                  <p v-for="(err, index) in errCorrecao" :key="index">
                    <small>{{ err }}</small>
                  </p>
                </div>
              </div>
            </div>
            <!-- FIM MENSAGENS DE ERRO E VALIDACAO DA NF -->
            <div class="row">
              <div class="col-md-12 col-12">
                <label class="lbl">Informe a justificativa do cancelamento:</label>
                <div class="form-group">
                  <textarea rows="5" cols="100" class="form-control" v-model="nf.obscan" ref="correcao"></textarea>
                  <label class="lbl">O texto deve possuir no mínimo 15 e no máximo 255 caracteres</label>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <v-button label="Confirmar Cancelamento" title="" :nb-btdef="true" icon="fa-check" @click="handleCancel">
            </v-button>
            <v-button label="Descartar" title="" icon="fa-rotate-left" @click="handleCancelDiscard"></v-button>
          </div>
        </div>
      </div>
    </div>
    <!-- FIM JUSTIFICATIVA DO CANCELAMENTO -->

    <!-- TELA MODAL PARA ENVIO DE EMAIL DO DANFE -->
    <email-form v-if="showFormEmail" :index="nf.codnf" tipo="DANFE" title="Envio de Danfe" @closeform="closeFormEmail"
      @send="handleSendEmail"></email-form>

    <!-- TELA MODAL PARA ENVIO DE EMAIL DA CORRECAO -->
    <email-form v-if="showFormEmailCC" :index="nf.codnf" tipo="CCE" title="Envio de Carta de Correção"
      @closeform="closeFormEmail" @send="handleSendEmailCC"></email-form>

    <md-message v-if="modalExcluir" code="delete" @confirm="handleExcluir()" @close="closeModal()"></md-message>

    <msg-banner-modal v-if="modalBannerIBSCBS" message="Nova Tributação IBS / CBS"
      url="https://s3.us-east-1.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/banners/banner_nb_nt.png"
      @onConfirm="handleConfirmBannerIBSCBS()" @close="closeModal()">
    </msg-banner-modal>
  </div>
</template>

<style scoped>
label {
  margin-bottom: 0;
}

.lbl-edit {
  margin-bottom: 0px;
}

.dropdown-total {
  z-index: 1051;
  margin-top: 3px;
  -webkit-border-radius: 4px;
  -moz-border-radius: 4px;
  border-radius: 4px;
  position: absolute;
  padding: 10px;
  z-index: 1000;
  float: left;
  min-width: 160px;
  list-style: none;
  background-color: #fff;
  border: 1px solid #00000033;
  box-shadow: 0 5px 10px #00000033;
  background-clip: padding-box;
}
</style>






// WEBPACK FOOTER //
// src/forms/nfsaida-form.vue